(function () {
  'use strict'
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'firebase'
      , 'luegg.directives'
      , 'foundation'
      , 'ngAudio'
      , 'ngSanitize'
      , 'ngFileUpload'
      , 'vkEmojiPicker'
      , 'autoCompleteModule'
    )
  angular.module('MktzapApp.Controllers')
    .controller('ChatController', chat)
  chat.$inject = ['$rootScope', '$scope', 'FoundationApi', '$firebaseAuth', '$firebaseArray', '$nwFirebaseArray', '$firebaseObject', '$http', 'ngAudio', 'ngAudioGlobals', 'NotificationFactory', '$sce', 'Upload', '$interval', 'AuthenticationService', 'QueryStringService', 'EmailService', 'StatusService', 'OperatorService', 'ConversationService', 'PollService', 'SectorService', 'CompanyService', 'HistoryService', 'DigitalSignService', 'TrackNotificationService', 'NotificationService', 'WhatsAppWebService', 'ChannelManager', 'MailingCampaignService', 'WaentService', 'CampaignService', 'ActiveLogService', 'CustomDocumentsService', 'HsmService', 'HistoryMetadataService', '$timeout', 'KnowledgeBaseService', 'UtilsService', 'MessagesPortalService', 'SMSService', 'BadwordsConfigService', 'EventService']
  function chat($rootScope, $scope, FoundationApi, $firebaseAuth, $firebaseArray, $nwFirebaseArray, $firebaseObject, $http, ngAudio, ngAudioGlobals, NotificationFactory, $sce, Upload, $interval, AuthenticationService, QueryStringService, EmailService, StatusService, OperatorService, ConversationService, PollService, SectorService, CompanyService, HistoryService, DigitalSignService, TrackNotificationService, NotificationService, WhatsAppWebService, ChannelManager, MailingCampaignService, WaentService, CampaignService, ActiveLogService, CustomDocumentsService, HsmService, HistoryMetadataService, $timeout, KnowledgeBaseService, UtilsService, MessagesPortalService, SMSService, BadwordsConfigService, EventService) {
    if (!AuthenticationService.haveCredentials()) {
      return;
    }

    var vm = this;

    vm.isStatus = isStatus;
    vm.modal_operators = [];
    vm.digitalSignature = {};
    vm.digitalSignature.documentPath = [];
    vm.channelManager = ChannelManager;
    vm.read_unread_auto_filter = 'all';
    vm.maxPageSize = 100;
    vm.openCardDaysSelected = 0;
    vm.filterWithoutStatus = false;
    vm.tempFilterAll = false;
    vm.metadata = $rootScope.company_metadata;
    vm.showEmoji = $rootScope.user_data.settings.show_emoticons;
    vm.protocolNumber = null
    vm.fileUpload = null;
    vm.audioSource = null;
    vm.messageEmojiPicker = {
      forceClose: function () {
        angular.element('[ng-model="vm.messageEmojiPicker"] [class="close-button"]').triggerHandler('click')
      }
    }
    openCardsDays()

    var types = {
      ALL: 0,
      OWN: 1,
      OWN_NONE: 2
    }

    vm.setPage = function (page, enabled) {
      if (enabled === false) return
      // vm.contacts[vm.sector_id].length / vm.maxPageSize;
      updatePageData(page)
      updatePagination()
    }

    function openCardsDays() {
      vm.openCardsDays = [
        { id: 0, label: $scope.labels.openCardsDays },
        { id: 2, label: '2 ' + $scope.labels.days },
        { id: 5, label: '5 ' + $scope.labels.days },
        { id: 10, label: '10 ' + $scope.labels.days },
        { id: 15, label: '15 ' + $scope.labels.days },
        { id: 20, label: '20 ' + $scope.labels.days },
        { id: 25, label: '25 ' + $scope.labels.days },
        { id: 30, label: '30 ' + $scope.labels.days }
      ]
    }

    function updatePageData(page) {
      vm.currentPage = page
      vm.startAt = vm.maxPageSize * (page - 1)
    }
    vm.endAt = function () {
      var endAt = vm.maxPageSize * vm.currentPage
      if (vm.contacts[vm.sector_id] && endAt > vm.contacts[vm.sector_id].length) {
        endAt = vm.contacts[vm.sector_id].length
      }
      return endAt
    }

    function singleButton(text, page, enabled) {
      return { enabled: enabled, page: page, text: text }
    }
    var lastTotal = null
    var lastPage = null
    function updatePagination() {
      var minPage = 1
      var total = (vm.contacts[vm.sector_id]) ? vm.contacts[vm.sector_id].length : 0
      if (lastTotal == total && lastPage == vm.currentPage) return
      lastTotal = total
      lastPage = vm.currentPage

      var maxPage = Math.ceil(total / vm.maxPageSize)
      if (vm.currentPage < minPage) {
        updatePageData(minPage)
      }
      if (vm.currentPage > maxPage) {
        updatePageData(maxPage)
      }
      var currentPage = vm.currentPage
      var buttons = []
      var firstRange = []
      var mainRange = []
      var lastRange = []
      if (maxPage > 3) {
        for (var i = minPage; i <= minPage + 2; ++i) {
          firstRange.push(i)
        }
      }
      var mainStart = currentPage - 2
      if (mainStart < minPage) mainStart = minPage
      var mainEnd = currentPage + 2
      if (mainEnd > maxPage) mainEnd = maxPage
      for (var i = mainStart; i <= mainEnd; ++i) {
        mainRange.push(i)
      }
      if (maxPage > 3) {
        for (var i = maxPage - 2; i <= maxPage; ++i) {
          lastRange.push(i)
        }
      }
      firstRange = firstRange.filter(function (value) {
        return mainRange.indexOf(value) == -1
      })
      lastRange = lastRange.filter(function (value) {
        return mainRange.indexOf(value) == -1
      })

      buttons.push(singleButton('«', currentPage - 1, (currentPage > minPage)))
      for (i in firstRange) {
        buttons.push(singleButton(firstRange[i], firstRange[i], true))
      }
      if (firstRange.length > 0 && (firstRange[firstRange.length - 1] + 1) != mainRange[0]) {
        buttons.push(singleButton('...', null, false))
      }

      for (i in mainRange) {
        buttons.push(singleButton(mainRange[i], mainRange[i], true))
      }

      if (lastRange.length > 0 && (mainRange[mainRange.length - 1] + 1) != lastRange[0]) {
        buttons.push(singleButton('...', null, false))
      }

      for (i in lastRange) {
        buttons.push(singleButton(lastRange[i], lastRange[i], true))
      }
      buttons.push(singleButton('»', currentPage + 1, (currentPage < maxPage)))

      vm.pagination = buttons
    }
    vm.updateMetadataFilter = function () {
      if ((vm.nameFilter.trim() != '') && filterWithoutStatusAllowed()) {
        vm.filterWithoutStatus = true
      }
      loadContacts()
    }
    $interval(updatePagination, 1000)
    vm.setReadUnreadAutoFilter = function (read_unread_auto) {
      vm.read_unread_auto_filter = read_unread_auto
      if (read_unread_auto != 'open_days') {
        vm.openCardDaysSelected = 0
      }
      loadContacts()
    }

    function filterContact(contact) {
      var read_unread_auto = true
      switch (vm.read_unread_auto_filter) {
        case 'all':
          read_unread_auto = true
          break
        case 'unread_interaction':
          read_unread_auto = !contact.auto && !contact.answered && (contact.metrics && contact.metrics.first_operator_answer_at)
          break
        case 'unread_no_interaction':
          read_unread_auto = !contact.auto && !contact.answered && (!contact.metrics || !contact.metrics.first_operator_answer_at)
          break
        case 'read':
          read_unread_auto = !contact.auto && contact.answered
          break
        case 'auto':
          read_unread_auto = contact.auto
          break
        case 'webchat_offline':
          if (typeof vm.web_chat_online_control[contact.id] !== 'undefined' && vm.web_chat_online_control[contact.id].last_disconnect) {
            var seconds_since_disconnected = Math.round((moment().format('x') - vm.web_chat_online_control[contact.id].last_disconnect) / 1000)
            var timeout = 3 * 60
            read_unread_auto = seconds_since_disconnected - timeout > 0
          } else {
            read_unread_auto = false
          }
          break
        case 'locked':
          vm.nameFilter = ''
          return contact.id == null ||
            contact.id == 'undefined' ||
            !vm.filterMetadata(contact)
        case 'open_days':
          if (vm.openCardDaysSelected) {
            var to = vm.getTo(contact)
            var contact_to = to.substring(0, to.length - 1)
            var time = to.substr(-1)
            read_unread_auto = !!((contact_to > Number(vm.openCardDaysSelected) && time === 'd'))
          }

          break
      }

      if (vm.filterWithoutStatus) {
        var returno = contact.id != null &&
          contact.id != 'undefined' &&
          vm.triagem(contact) &&
          vm.filterMetadata(contact) &&
          vm.filterOperators(contact) &&
          read_unread_auto
      } else {
        var returno = contact.id != null &&
          contact.id != 'undefined' &&
          vm.filterStatus(contact) &&
          vm.triagem(contact) &&
          vm.filterMetadata(contact) &&
          vm.filterOperators(contact) &&
          read_unread_auto
      }

      return returno
    }

    vm.isWebchatOnline = function (contact) {
      if (getType(contact) != 'web' || typeof vm.web_chat_online_control[contact.id] === 'undefined') return null
      if (vm.web_chat_online_control[contact.id].last_disconnect) {
        var seconds_since_disconnected = Math.round((moment().format('x') - vm.web_chat_online_control[contact.id].last_disconnect) / 1000)
        var timeout = 3 * 60
        return seconds_since_disconnected - timeout <= 0
      } else {
        return true
      }
    }
    /* FILTERED FIREBASE ARRAY */
    var FilteredFirebaseArray = $nwFirebaseArray.$extend({
      $$added: function (snap) {
        var rec = $nwFirebaseArray.prototype.$$added.call(this, snap)
        if (filterContact(rec)) {
          return rec
        }
      },
      filterContact: filterContact
    })
    /* FILTERED FIREBASE ARRAY */
    var temp_filters = angular.copy(vm.default_filters)
    temp_filters = QueryStringService.getFilters(temp_filters)
    var current_status = temp_filters ? temp_filters.status : ''
    $interval(function () {
      var filters = angular.copy(vm.default_filters)
      filters = QueryStringService.getFilters(filters)
      if (current_status != filters.status) {
        current_status = filters.status
        loadContacts()
      }
    }, 1000)

    function formatTime(seconds) {
      if (seconds == 0) { return '' }
      var minutes = parseInt(seconds / 60) % 60
      var hours = parseInt(seconds / 3600)
      var days = parseInt(seconds / (3600 * 24))

      if (days > 0) {
        return days + 'd'
      }
      if (hours > 0) {
        return hours + 'h'
      }
      if (minutes > 0) {
        return minutes + 'm'
      }

      return seconds + 's'
    }

    vm.getTe = function (contact) {
      if (!contact.metrics) return formatTime(0)
      var now = moment().format('X')
      var last_te_seconds = 0
      if (contact.metrics.latest_operator_answer_at && contact.metrics.latest_contact_chat_message_at) {
        last_te_seconds = contact.metrics.latest_operator_answer_at - contact.metrics.latest_contact_chat_message_at
      } else if (contact.metrics.latest_contact_chat_message_at) {
        last_te_seconds = now - contact.metrics.latest_contact_chat_message_at
      }
      if (last_te_seconds < 0) {
        last_te_seconds = 0
      }
      return formatTime(last_te_seconds)
    }

    vm.getPte = function (contact) {
      if (!contact.metrics) return formatTime(0)
      var now = moment().format('X')
      var pte_seconds = 0
      if (contact.metrics.first_start_chat_at && contact.metrics.first_operator_answer_at) {
        pte_seconds = contact.metrics.first_operator_answer_at - contact.metrics.first_start_chat_at
      } else if (contact.metrics.first_start_chat_at) {
        pte_seconds = now - contact.metrics.first_start_chat_at
      }
      if (pte_seconds < 0) {
        pte_seconds = 0
      }
      return formatTime(pte_seconds)
    }

    vm.getTo = function (contact) {
      if (!contact.metrics || !contact.metrics.first_start_chat_at) return formatTime(0)
      var now = moment().format('X')
      var to_seconds = now - contact.metrics.first_start_chat_at
      if (to_seconds < 0) {
        to_seconds = 0
      }
      return formatTime(to_seconds)
    }

    vm.is_loading = true
    vm.first_load = true
    vm.customer_recurrence = 0
    $rootScope.vm = vm
    vm.notify_sound = ngAudio.load(baseUrl + '/assets/sounds/notify.wav')
    vm.contacts = {}
    vm.contacts_all = {}
    vm.selectedUser = {}
    vm.messages = {}
    vm.message = {}
    vm.messagesHistory = {}
    vm.default_filters = { status: '', kind: '' }
    vm.filters = { status: '', kind: '' }
    vm.filters = QueryStringService.getFilters(vm.filters)
    vm.nameFilter = ''
    vm.getType = getType
    vm.getChannelType = getChannelType
    vm.selectUser = selectUser
    vm.sendMessage = sendMessage
    vm.sendCustomMessage = sendCustomMessage
    vm.sendPoll = sendPoll
    vm.getClass = getClass
    vm.getMessageHistoryClass = getMessageHistoryClass
    vm.getName = getName
    vm.getMessageHistoryName = getMessageHistoryName
    vm.filterFn = filterFn
    vm.filterStatus = filterStatus
    vm.changeSector = changeSector
    vm.displayNumber = displayNumber
    vm.hasActiveChat = hasActiveChat
    vm.setStatus = setStatus
    vm.setAnswered = setAnswered
    vm.filterMessage = filterMessage
    vm.checkAttaching = checkAttaching
    vm.attach = attach
    vm.hasUnanswered = hasUnanswered
    vm.isCurrentOperator = isCurrentOperator
    vm.setSector = setSector
    vm.setOperator = setOperator
    vm.saveNotes = saveNotes
    vm.resetNotes = resetNotes
    vm.activeEmail = activeEmail
    vm.openActiveWhatsapp = openActiveWhatsapp
    vm.openActiveWaent = openActiveWaent
    vm.createActiveEmail = createActiveEmail
    vm.createActiveWhatsapp = createActiveWhatsapp
    vm.createActiveSms = createActiveSms
    vm.sending = false
    vm.downloadingChat = false
    vm.resendingEmail = false
    vm.notificationSetup = notificationSetup
    vm.fetchStatuses = fetchStatuses
    vm.authAndLoadContacts = authAndLoadContacts
    vm.loadEmailConfigs = loadEmailConfigs
    vm.loadWhatsappConfigs = loadWhatsappConfigs
    vm.loadWaentConfigs = loadWaentConfigs
    vm.fetchPolls = fetchPolls
    vm.cancelAttach = cancelAttach
    vm.upload = upload
    vm.conversationStatusHelper = conversationStatusHelper
    vm.sendAttach = sendAttach
    vm.log = log
    vm.updateKey = updateKey
    vm.hasMetadata = hasMetadata
    vm.confirmStatus = confirmStatus
    vm.confirmedStatus = confirmedStatus
    vm.cancelConfirmStatus = cancelConfirmStatus
    vm.filterMetadata = filterMetadata
    vm.triagem = triagem
    vm.getCustomerRecurrence = getCustomerRecurrence
    vm.isClassified = isClassified
    vm.removeClassification = removeClassification
    vm.checkTrackNotification = checkTrackNotification
    vm.selectContract = selectContract
    vm.registerDelivery = registerDelivery
    vm.getUserPhone = getUserPhone
    vm.show_knowledge_base = false
    vm.knowledge_base = {}
    vm.autoCompleteOpened = false
    vm.checkAiClassification = checkAiClassification
    vm.setAiClassification = setAiClassification
    vm.checkMailing = checkMailing
    vm.checkCampaign = checkCampaign
    vm.checkAnsweredFromWebhook = checkAnsweredFromWebhook
    vm.checkCustomDocuments = checkCustomDocuments
    vm.content = []
    vm.clicksign_fullname = null
    vm.clicksign_birthdate = null
    vm.digital_signature_docs = []
    vm.show_history = false
    vm.show_hsm = false
    vm.show_modal_close_option = false
    vm.show_automatic_answers = false
    vm.cardsData = null
    vm.selectedCard = null
    vm.web_chat_online_control = {}
    vm.trackKeys = 0
    vm.hsmSet = []
    vm.showTabSignature = true
    vm.showTabDocuments = false
    vm.popover = false
    vm.elementDegree = 0
    vm.preventDefaultDigitalSignature = false
    vm.hasUnsavedChanges = false
    vm.tabChatModal = "digital-signature";

    // Filtro por operador
    vm.temp_filter_operators = {}
    vm.filter_operators = {}
    vm.operatorFilter = operatorFilter
    vm.filterOperators = filterOperators
    vm.setFiltersOperators = setFiltersOperators
    vm.operatorsFilterToggle = operatorsFilterToggle
    vm.getOperatorsFilteredMessage = getOperatorsFilteredMessage
    vm.allow_track_notification = false
    vm.ai_classification = false
    vm.ai_intent = false
    vm.trackContracts = false
    vm.trackEmissions = false
    vm.tracknotifications = false
    vm.tracknotification = false
    vm.canSendWhatsappActive = canSendWhatsappActive
    vm.dist = $rootScope.automatic_distribution
    vm.dist_on = $rootScope.automatic_distribution.enabled
    vm.canSendWaentActive = canSendWaentActive
    vm.delLockedContact = delLockedContact
    vm.canSendSmsActive = canSendSmsActive
    vm.openActiveSms = openActiveSms
    vm.changeDdi = changeDdi
    vm.changeDdiWhatsAppWeb = changeDdiWhatsAppWeb

    vm.fileMaxSize = "5MB";

    var notifSet = new NotificationFactory({
      position: 'bottom-right'
    })

    Firebase.goOnline()
    // When leave this Controller, stop firebase
    $scope.$on('$destroy', function () {
      Firebase.goOffline()
    })

    vm.fetchStatuses()
    vm.loadEmailConfigs()
    vm.loadWhatsappConfigs()
    vm.loadWaentConfigs()
    vm.fetchPolls()
    vm.notificationSetup()
    checkCustomDocuments()

    OperatorService.operator()
      .$promise
      .then(function (data) {
        vm.operator = data
        vm.sectors = data.sectors
        OperatorService.token()
          .$promise
          .then(function (token) {
            vm.authAndLoadContacts(token.token)
          })
          .catch(function (data) {
            errorHandler(data, $scope.labels.survey)
          })
      })
      .catch(function (data) {
        errorHandler(data, $scope.labels.errorLoadOpDep)
      })

    CompanyService.loadMetadataDefinition().$promise.then(function (resp) {
      vm.metadata_definition = resp
    })
      .catch(function (data) {
        NotificationService.errorHandler(data, $scope.labels.errorLoadOpDep)
      })

    function updateKey(key, field, show_message = true) {
      if (field && key) {
        if (field.key == 'cpf' && key.value == null) {
          errorHandler(null, $scope.labels.validCpf)
        } else {
          if (checkRequiredFields(field)) {
            key.contact_metadata_definition_id = field.id
            key.contact_id = vm.selectedUser[vm.sector_id].id
            vm.content_metadata = field
            saveForm(show_message)
          }
        }
      }
    }

    function isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n)
    }

    function checkRequiredFields(field_param, status_id) {
      var confirm = true
      var should_require = true

      for (var i = 0, len = vm.statuses.length; i < len; i++) {
        if (vm.statuses[i].id == status_id) {
          should_require = !!parseInt(vm.statuses[i].should_require)
          break
        }
      }

      for (var i = 0, len = vm.metadata_definition.length; i < len; i++) {
        if (typeof vm.content[i] !== 'undefined') {
          var field; var maskChoice = null
          if (Array.isArray(vm.content) && vm.content.length) {
            if (field_param) {
              if (field_param.key != vm.metadata_definition[i].key) {
                continue
              }
            } else if (vm.content[i].hasOwnProperty('params') && vm.content[i].params != null && vm.content[i].params.hasOwnProperty('maskChoice')) {
              maskChoice = vm.content[i].params.maskChoice
            }
            if (!vm.content[i].metadata) {
              field = ''
            } else {
              field = vm.content[i].metadata.value
            }
          }
          if (Boolean(vm.metadata_definition[i].is_active) && vm.metadata_definition[i].params) {
            if (vm.metadata_definition[i].params.required && should_require) {
              var label = maskChoice || ((field_param && field_param.params && field_param.params.maskChoice) ? field_param.params.maskChoice : null) || vm.metadata_definition[i].label
              var use_function = ''

              if (isNumber(field)) {
                if (field <= 0) {
                  field = ''
                } else {
                  field = field.toString()
                }
              }
              if ((!field || !field.trim()) && should_require) {
                confirm = false
                NotificationService.errorHandler('', $scope.labels.field + " '" + label.toUpperCase() + "' " + $scope.labels.fieldRequired + '!')
                break
              }

              if (field_param && field_param.hasOwnProperty('params') && field_param.params.hasOwnProperty('maskChoice')) {
                use_function = vm.metadata_definition[i].params[field_param.params.maskChoice].use_function
                maskChoice = field_param.params.maskChoice
              } else if (maskChoice != null) {
                use_function = vm.metadata_definition[i].params[maskChoice].use_function
              } else if (vm.metadata_definition[i].hasOwnProperty('params') && vm.metadata_definition[i].params.hasOwnProperty('use_function')) {
                use_function = vm.metadata_definition[i].params.use_function
              }
            }
          }
        }
      }
      return confirm
    }

    function saveForm(show_message) {
      ConversationService
        .saveContactMetadata(vm.content)
        .$promise
        .then(function (data) {
          if (show_message) {
            successHandler(data, $scope.labels.sucSave)
          }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorSaveFields)
        })
    }
    function conversationStatusHelper(contact) {
      if ((!contact.auto || contact.auto == '0') && !contact.answered && !contact.operator_id) { return 'status-alert' }
      if ((!contact.auto || contact.auto == '0') && !contact.answered && contact.operator_id) { return 'status-alert' }
      if ((!contact.auto || contact.auto == '0') && contact.answered) { return 'status-ok' }
      if (contact.auto == '1') { return 'status-warning' }

      return 'status-alert'
    }

    function conversationStatusEventChecker(contact) {
      if (contact.auto == '1') { return 'status-warning' }
      if (!contact.auto && !contact.answered) { return 'status-alert' }
      if (!contact.auto && contact.answered) { return 'status-ok' }

      return 'status-error'
    }

    function notificationSetup() {
      ngAudioGlobals.unlock = false

      var notifSet = new NotificationFactory({
        position: 'bottom-right'
      })
      Notification.requestPermission()
      $interval(function () {
        var hasUnanswered = false
        for (var i in vm.has_unanswered) {
          hasUnanswered = hasUnanswered || vm.has_unanswered[i]
        }
        if (hasUnanswered) {
          $rootScope.favicon_url = baseUrl + '/assets/images/mktzap-favicon-unanswered.png'
        } else {
          $rootScope.favicon_url = baseUrl + '/assets/images/mktzap-favicon.png'
        }
      }, 1000)
    }
    function notifyMe(config) {
      // Let's check if the browser supports notifications
      if (!('Notification' in window)) {
        console.log($scope.labels.errorBrowser)
      }
      // Let's check whether notification permissions have already been granted
      else if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        var notification = new Notification(config.message, {
          icon: config.icon
        })
      }
      // Otherwise, we need to ask the user for permission
      else if (Notification.permission !== 'denied') {
        Notification.requestPermission(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === 'granted') {
            var notification = new Notification(config.message, {
              icon: config.icon
            })
          }
        })
      }
      // At last, if the user has denied notifications, and you
      // want to be respectful there is no need to bother them any more.
    }
    function filterFinalizationStatus(statuses) {
      var filteredStatuses = angular.copy(statuses)

      var filtered = filteredStatuses.filter((value) => {
        return value.should_close == 1
      })

      return filtered
    }
    function fetchStatuses() {
      StatusService.all()
        .$promise
        .then(function (data) {
          vm.statuses = data
          vm.finalizationStatus = filterFinalizationStatus(data)
          angular.forEach(vm.statuses, function (status, key) {
            if (status.should_close == 0 && status.is_default == 1) {
              vm.statuses.default_classification_id = status.id
            }
          })
        }).catch(function (resp) {
          if (resp.status != 401 && typeof resp.data.pause_data === 'undefined') {
            errorHandler(resp, $scope.labels.errorLoadStatus)
          }
        })
    }
    function isStatus(status_id) {
      var filters = angular.copy(vm.default_filters)
      vm.filters = QueryStringService.getFilters(filters)
      return vm.filters['status'].trim() == status_id
    }
    function loadContacts(token) {
      vm.is_loading = true
      var contactsRef = null
      var webChatOnlineCntrolRef = null
      var promises = []
      vm.counters = {
        contacts: {},
        sectors: {},
        statuses: {}
      }
      $rootScope.status_unread_count = vm.counters.statuses
      angular.forEach(vm.sectors, function (sector, key) {
        contactsRef = new Firebase(firebase_url + '/contacts/' + vm.operator.company_id + '/' + sector.id)
        contactsRef = contactsRef.orderByPriority()

        contactsRef.on('child_added', function (snapshot) {
          var contact = snapshot.val()
          if (typeof vm.contact_cache === 'undefined') {
            vm.contact_cache = {}
          }
          vm.contact_cache[contact.id] = {
            auto: contact.auto,
            answered: contact.answered
          }
        })
        contactsRef.on('child_changed', function (snapshot) {
          var contact = snapshot.val()

          /** atualizar contato de formalização após uma atualização no firebase */
          if (contact && contact.digital_signature && !contact.new_digital_signature) { // TODO REMOVER APOS REALIZAR RETROCOMPATIBILIDADE
            mergeFormalizationContactRealTime(contact)
          }

          if (typeof vm.contact_cache === 'undefined') {
            vm.contact_cache = {}
          }
          var old_contact = vm.contact_cache[contact.id] || {}
          vm.contact_cache[contact.id] = {
            auto: contact.auto,
            answered: contact.answered
          }
          if (vm.selectedUser[vm.sector_id] && Object.keys(vm.selectedUser[vm.sector_id]).length && vm.selectedUser[vm.sector_id].id && !vm.statusManuallySet) {
            if (contact.id == vm.selectedUser[vm.sector_id].id) {
              if (vm.selectedUser[vm.sector_id].status != contact.status) {
                FoundationApi.publish('dlgChatModal', 'close')
                successHandler(false, $scope.labels.changedStatus)
              }
            }
          }

          if (vm.selectedUser[vm.sector_id] && Object.keys(vm.selectedUser[vm.sector_id]).length &&
            vm.selectedUser[vm.sector_id].data && snapshot.val().data && vm.selectedUser[vm.sector_id].data.contact_phone == snapshot.val().data.contact_phone) {
            return
          }

          if (snapshot.val().answered == false && snapshot.val().auto == false) {
            if (typeof old_contact.auto === 'undefined' || (old_contact.auto === true && old_contact.auto != contact.auto) || (contact.answered === false && old_contact.answered != contact.answered)) {
              if ($rootScope.user_data.settings.sound_notification) {
                vm.notify_sound.play()
              }
              if ($rootScope.user_data.settings.desktop_notification) {
                notifyMe({
                  message: $scope.labels.newMes + ' ' + snapshot.val().name,
                  icon: snapshot.val().profile_pic_public_path
                })
              }
            }
          }
        })
        var type = getUserViewMode(types)

        var operator_data = {
          type: type,
          id: vm.operator.id,
          types: types
        }

        vm.contacts[sector.id] = new FilteredFirebaseArray(contactsRef, sector.id, current_status, vm.counters, operator_data)
        promises.push(vm.contacts[sector.id].$loaded())

        if (webChatOnlineCntrolRef === null) {
          webChatOnlineCntrolRef = new Firebase(firebase_url + '/web_chat_online_control/' + vm.operator.company_id)

          var fbAuth = $firebaseAuth(webChatOnlineCntrolRef)

          fbAuth.$authWithCustomToken(token, function (error, auth) {

          }, {
            remember: 'none'
          }).then(function (authData) {
            if (authData) {
              vm.web_chat_online_control = $firebaseObject(webChatOnlineCntrolRef)
            }
          })
            .catch(function (error) {
              // TODO: Reestruturar essa validação de webchat quando for fazer o novo webchat
            })
        }
      })
      Promise.all(promises).then(function () {
        vm.is_loading = false
        vm.filterWithoutStatus = false
      })
    }

    function getUserViewMode(types) {
      var type = 0

      if ($rootScope.user_data.role == $rootScope.profiles.ROLE_ADMIN) {
        type = types.ALL
      } else if (typeof vm.dist !== 'undefined' &&
        typeof vm.dist_on !== 'undefined' &&
        vm.dist_on === true) {
        if ($rootScope.user_data.role == $rootScope.profiles.ROLE_MANAGER) {
          type = types.ALL
        } else {
          type = types.OWN
        }
      } else {
        var triage = 0

        if (typeof vm.metadata !== 'undefined' &&
          typeof vm.metadata.triage !== 'undefined') {
          triage = vm.metadata.triage
        }

        /* TRIAGEM */
        // 1. Todos os operadores e gestores veem tudo
        if (triage == $rootScope.TriageModes.BASIC) {
          type = types.ALL
        }

        // 2. Apenas os gestores vêem tudo, operadores vêem apenas aquilo atribuído à eles
        if (triage == $rootScope.TriageModes.MANAGER) {
          if ($rootScope.user_data.role == $rootScope.profiles.ROLE_MANAGER) {
            type = types.ALL
          }
          if ($rootScope.user_data.role == $rootScope.profiles.ROLE_OPERATOR) {
            type = types.OWN
          }
        }

        // 3. Os operadores vêem tudo atribuído à eles e tudo que não está atribuído a ninguém
        if (triage == $rootScope.TriageModes.OPERATOR) {
          if ($rootScope.user_data.role == $rootScope.profiles.ROLE_MANAGER) {
            type = types.ALL
          } else {
            type = types.OWN_NONE
          }
        }
      }

      return type
    }

    function authAndLoadContacts(token) {
      $rootScope.sectors = vm.sectors
      changeSector(vm.sectors[0])
      var contactsRef = new Firebase(firebase_url + '/contacts/' + vm.operator.company_id + '/' + vm.sector_id)
      var fbAuth = $firebaseAuth(contactsRef)

      fbAuth.$authWithCustomToken(token, function (error, auth) {

      }, {
        remember: 'none'
      })
      fbAuth.$onAuth(function (authData) {
        if (authData == null) {
          OperatorService
            .resetToken()
            .$promise
            .then(function (token) {
            })
        }

        if (authData && vm.first_load) {
          vm.first_load = false
          loadContacts(token)
        }
      })
    }
    function loadEmailConfigs() {
      EmailService.configForActiveEmail(function (data) {
        vm.email_settings = data
      }, function (error) {
        errorHandler(error, $scope.labels.errorEmailConfig)
      })
    }

    function loadWhatsappConfigs(callback) {
      if (!whatsappActiveAllowed()) {
        return false
      }

      vm.whatsappChannels = []
      vm.hsmSet = []
      vm.active_whatsApp = {}
      vm.activeWhatsapp = {}
      getCountriesWhatsAppWeb()

      WhatsAppWebService.user(function (channels) {
        vm.whatsappChannels = channels
        if (typeof callback === 'function') {
          if (!canSendWhatsappActive()) {
            NotificationService.warningHandler(null, $scope.labels.noAllowed)
            return
          }
          callback()
        }
      }, function (error) {
        NotificationService.errorHandler(error, $scope.labels.errorLoadWhatsappChannel)
      })

      HsmService.all(function (hsmSet) {
        vm.hsmSet = hsmSet
      }, function (error) {
        NotificationService.errorHandler(error, 'Erro ao carregar os modelos (HSM).')
      })
    }

    function loadSmsConfigs(callback) {
      if (!canSendSmsActive()) {
        return false
      }
      getCountriesSms()

      vm.active_sms.channels = []

      SMSService.getAllChannels((channels) => {
        vm.active_sms.channels = channels

        if (typeof callback === 'function') {
          if (!canSendSmsActive()) {
            NotificationService.warningHandler(null, $scope.labels.noAllowed)
            return
          }
          callback()
        }
      })
    }

    function loadWaentConfigs(callback) {
      if (!waentActiveAllowed()) {
        return false
      }

      vm.waentChannels = []
      vm.hsmSet = []

      WaentService.user(function (channels) {
        vm.waentChannels = channels
        if (typeof callback === 'function') {
          if (!canSendWaentActive()) {
            NotificationService.warningHandler(null, $scope.labels.noAllowed)
            return
          }
          callback()
        }
      }, function (error) {
        NotificationService.errorHandler(error, $scope.labels.errorLoadWaentChannel)
      })

      HsmService.all(function (hsmSet) {
        vm.hsmSet = hsmSet
      }, function (error) {
        NotificationService.errorHandler(error, 'Erro ao carregar os modelos (HSM).')
      })
    }

    function filterWithoutStatusAllowed() {
      return $rootScope.company_metadata &&
        $rootScope.company_metadata.hasOwnProperty('allow') &&
        $rootScope.company_metadata.allow['filter-without-status']
    }

    function removeResponsibleOnTransferEnabled() {
      return $rootScope.company_metadata &&
        $rootScope.company_metadata.allow &&
        $rootScope.company_metadata.allow.remove_responsible_on_transfer &&
        $rootScope.company_metadata.allow.remove_responsible_on_transfer.enabled &&
        $rootScope.company_metadata.allow.remove_responsible_on_transfer.enabled === true
    }

    function whatsappActiveAllowed() {
      return $rootScope.company_metadata &&
        $rootScope.company_metadata.hasOwnProperty('allow') &&
        $rootScope.company_metadata.allow['whatsapp-active']
    }

    function waentActiveAllowed() {
      return $rootScope.company_metadata &&
        $rootScope.company_metadata.hasOwnProperty('allow') &&
        $rootScope.company_metadata.allow['waent-active']
    }

    function canSendWhatsappActive() {
      return whatsappActiveAllowed() &&
        $rootScope.user_data.role === $rootScope.profiles.ROLE_OPERATOR &&
        Array.isArray(vm.whatsappChannels) &&
        vm.whatsappChannels.length &&
        hasActiveWhatsApp()
    }

    function canSendSmsActive() {
      return $rootScope.user_data.role === $rootScope.profiles.ROLE_OPERATOR &&
        $rootScope.company_metadata.allow['sms-active-home']
    }

    function canSendWaentActive() { // Usado para o botão da tela inicial do lado do search
      return waentActiveAllowed() &&
        $rootScope.user_data.role === $rootScope.profiles.ROLE_OPERATOR &&
        Array.isArray(vm.waentChannels) &&
        vm.waentChannels.length &&
        hasActiveWaent() &&
        $rootScope.company_metadata.allow['waent-hsm-active-home']
    }

    vm.canSendHsm = function () {
      return waentActiveAllowed() &&
        Array.isArray(vm.waentChannels) &&
        $rootScope.company_metadata.allow['waent-hsm-active']
    }

    function hasActiveWhatsApp() {
      return vm.whatsappChannels.some(function (wpp) {
        if (wpp.can_send_active) {
          return wpp.can_send_active
        }
      })
    }

    function hasActiveWhatsAppEnterprise() {
      var user = vm.selectedUser[vm.sector_id]
      var channelSelected = vm.waentChannels.find(function (channel) {
        if (channel.id == user.data.channel_id) {
          return channel
        }
      })

      if (!channelSelected) {
        return false
      }

      return channelSelected.can_send_active
    }

    function hasActiveWaent() {
      return vm.waentChannels.some(function (waent) {
        if (waent.can_send_active) {
          return waent.can_send_active
        }
      })
    }

    function fetchPolls() {
      vm.polls = $rootScope.polls
    }
    function log(data) {
      console.log(data)
    };
    function activeEmail() {
      FoundationApi.publish('dlgActiveEmail', 'open')
    }

    /* Abre modal do filtro por operador */
    function operatorFilter() {
      FoundationApi.publish('dlgOperatorFilter', 'open')
    }

    function filterOperators(contact) {
      var has_filter = false
      angular.forEach(vm.filter_operators, function (value, key) {
        if (value) {
          has_filter = true
        }
      })
      if (Object.keys(vm.filter_operators).length == 0 || !has_filter) return true

      var empty = false // don't display empty
      if (typeof vm.filter_operators['-1'] !== 'undefined' && vm.filter_operators['-1']) {
        empty = true // display empty
      }
      if (!contact.operator_assigned_id) return empty
      if (typeof vm.filter_operators[contact.operator_assigned_id] !== 'undefined' && vm.filter_operators[contact.operator_assigned_id]) {
        return true
      }

      return false
    }

    function operatorsFilterToggle() {
      var selected = vm.temp_filter_all;
      vm.temp_filter_operators['-1'] = selected;
      angular.forEach(vm.users_filter, function (value) {
        if (vm.tempFilterAll == false) vm.temp_filter_operators[value.id] = true;
        else vm.temp_filter_operators[value.id] = false;
      });
    }

    function setFiltersOperators() {
      vm.filter_operators = angular.copy(vm.temp_filter_operators)
      loadContacts()
      FoundationApi.publish('dlgOperatorFilter', 'close')
    }

    function getOperatorsFilteredMessage() {
      var message_all = 'Você está visualizando os atendimentos de todos usuários.'
      var has_any = false
      var type = getUserViewMode(types)
      var message

      switch (type) {
        case 1:
          has_any = true
          message = 'Você está vendo os atendimentos atribuídos a você.'
          break

        case 2:
          has_any = true
          message = 'Você está vendo os atendimentos atribuídos a você e os não atribuídos a nenhum outro usuário.'
          break

        default:
          message = 'Você está visualizando os atendimentos'
          break
      }

      if (Object.keys(vm.filter_operators).length > 0) {
        var operators = []
        for (var id in vm.filter_operators) {
          if (id != '-1' && vm.filter_operators[id]) {
            var name = null
            angular.forEach(vm.users_filter, function (value) {
              if (value.id == id) {
                name = value.display_name
              }
            })
            if (name != null) {
              operators.push(name)
              has_any = true
            }
          }
        }
        if (typeof vm.filter_operators['-1'] !== 'undefined' && vm.filter_operators['-1']) {
          message += ' <b>sem operador</b>'
          has_any = true
          if (operators.length > 0) {
            message += ' e '
          }
        }

        message += ' '
        if (operators.length == 1) {
          message += 'do usuário '
        } else if (operators.length > 1) {
          message += 'dos usuários '
        }
        for (var i = 0; i < operators.length - 1; ++i) {
          if (i > 0) {
            message += ', '
          }
          message += '<b>' + operators[i] + '</b>'
        }
        if (operators.length == 1) {
          message += operators[0]
        } else if (operators.length > 1) {
          message += ' e ' + '<b>' + operators[operators.length - 1] + '</b>'
        }
      }

      return $sce.trustAsHtml((has_any) ? message : message_all)
    }

    function openActiveWhatsapp() {
      vm.activeWhatsapp = {}
      vm.active_whatsApp = {}
      loadWhatsappConfigs(function () {
        FoundationApi.publish('dlgActiveWhatsapp', 'open')
      })
    }

    function openActiveWaent() {
      vm.activeWaent = {}
      loadWaentConfigs(function () {
        FoundationApi.publish('dlgActiveWaent', 'open')
      })
    }

    function openActiveSms() {
      vm.activeSms = {}
      vm.active_sms = {}
      loadSmsConfigs(function () {
        FoundationApi.publish('dlgActiveSms', 'open')
      })
    }

    function createActiveEmail(mail, sector) {
      var sector_id = sector.id
      EmailService
        .createActiveEmail({ id: sector_id }, mail)
        .$promise
        .then(function (data, status, headers, config) {
          if (data.success) {
            FoundationApi.publish('dlgActiveEmail', 'close')
            vm.activeEmail[vm.sector_id] = {}
            var contact_id = data.contact_id
            for (var i in vm.contacts[sector_id]) {
              if (vm.contacts[sector_id][i].$id == contact_id) {
                selectUser(sector, vm.contacts[sector_id][i])
                break
              }
            }
          } else {
            errorHandler(data, $scope.labels.errorEmailThread)
          }
        }).catch(function (data) {
          errorHandler(data, $scope.labels.errorEmailThread)
        })
    }

    vm.getClassFilter = function () {
      vm.filterUsersSector = false
      vm.filterNewMail = false
      vm.mediumClass = ''
      var size = 24

      if ($rootScope.allowedRoles([$rootScope.profiles.ROLE_MANAGER, $rootScope.profiles.ROLE_ADMIN])) {
        vm.filterUsersSector = true
        size = size - 3
      }

      if (typeof vm.email_settings !== 'undefined' &&
        typeof vm.sector_id !== 'undefined' &&
        typeof vm.email_settings[vm.sector_id] !== 'undefined') {
        if (vm.email_settings[vm.sector_id].length > 0) {
          vm.filterNewMail = true
          size = size - 3
        }
      }

      vm.mediumClass = 'medium-' + size

      if ($rootScope.company_metadata.triage === $rootScope.TriageModes.BASIC) {
        vm.mediumClass = 'medium-21'
        if (vm.filterNewMail) {
          vm.mediumClass = 'medium-18'
        }
        vm.filterUsersSector = true
      }

      return vm.mediumClass
    }

    function createActiveWhatsapp() {
      if (!vm.activeWhatsapp.channel_id || !vm.activeWhatsapp.message || !vm.activeWhatsapp.phone_number) {
        NotificationService.warningHandler(null, 'Por favor, preencha os campos obrigatórios!')
        return false
      }
      vm.activeWhatsapp.sector_id = vm.sector_id
      WhatsAppWebService
        .createActiveWhatsapp(vm.activeWhatsapp)
        .$promise
        .then(function (data, status, headers, config) {
          if (data.success) {
            NotificationService.successHandler(data, 'Mensagem enviada com sucesso!')
            FoundationApi.publish('dlgActiveWhatsapp', 'close')
          } else {
            NotificationService.warningHandler(null, data.message)
          }
        }).catch(function (response) {
          if (response && response.status === 401) {
            return NotificationService.warningHandler(null, 'Você não tem permissão para esta ação.')
          }
          NotificationService.errorHandler(null, response.data.message)
        })
    }

    function createActiveSms() {
      if (!vm.activeSms.channel_id || !vm.activeSms.message || !vm.activeSms.phone_number || !vm.activeSms.ddi) {
        NotificationService.warningHandler(null, 'Por favor, preencha os campos obrigatórios!')
        return false
      }
      vm.activeSms.sector_id = vm.sector_id

      SMSService
        .createActiveSms(vm.activeSms)
        .$promise
        .then((data) => {
          if (data.success) {
            NotificationService.successHandler(data, 'Mensagem enviada com sucesso!')
            FoundationApi.publish('dlgActiveSms', 'close')
          } else {
            NotificationService.warningHandler(null, data.message)
          }
        }).catch((data) => {
          NotificationService.errorHandler(null, data.data.message)
        })
    }

    vm.showHsm = function () {
      vm.activeWaent = {}
      vm.activeWaent.hsm_id = null
      vm.activeWaent.hsmTemplate = ''
      vm.activeWaent.hsmParams = []
      vm.backToAttendance()
      vm.show_hsm = true
    }

    vm.showKnowledgeBaseText = function (text) {
      return UtilsService.jsonParseText(text)
    }

    vm.sendKnowledgeBase = function (knowledge_base) {
      vm.message[vm.sector_id] = UtilsService.jsonParseText(knowledge_base.text)

      KnowledgeBaseService
        .increments(knowledge_base)
        .$promise
        .then(function (data) {
          vm.show_knowledge_base = false
        }).catch(function (data) {
          errorHandler(data, $scope.labels.chatKnowledgeBaseAddError)
        })
    }

    vm.showKnowledgeBase = function () {
      if (vm.preventDefaultDigitalSignature) {
        return false
      }
      closeAutomaticAnswersModal()
      vm.show_hsm = false
      vm.show_history = false
      vm.show_knowledge_base = true

      vm.searchFor = ''
      vm.message[vm.sector_id] = ''

      if (!vm.is_loading) {
        KnowledgeBaseService
          .knowledgeBaseMoreUsed()
          .$promise
          .then(function (data) {
            vm.is_loading = true
            vm.knowledge_base = data.sort(function (a, b) {
              return -(a.id - b.id || a.name.localeCompare(b.name))
            })
            vm.is_loading = false
          }).catch(function (data) {
            errorHandler(data, $scope.labels.chatKnowledgeBaseLoadError)
          })
      }
    }

    vm.searchTerm = function () {
      if (vm.searchFor === '') {
        vm.showKnowledgeBase()
        return
      }
      if (vm.searchFor.length >= 255) {
        NotificationService.errorHandler(null, 'Busca deve conter no máximo 255 caracteres.')
        vm.showKnowledgeBase()
        return
      }

      var canSearch = false; var search = ''

      if (isNaN(vm.searchFor) && vm.searchFor.length > 2) {
        canSearch = true
        var regex = /(\#)(\d+)(.*)/
        search = vm.searchFor.replace(regex, '$2')
        if (isNaN(search)) {
          search = vm.searchFor
        }
      } else if (!isNaN(vm.searchFor)) {
        canSearch = true
        search = vm.searchFor
      } else if (isNaN(vm.searchFor) && vm.searchFor.length <= 2) {
        NotificationService.warningHandler(null, 'Informe uma palavra com mais que 2 caracteres.')
        return
      }

      if (canSearch) {
        KnowledgeBaseService
          .searchKnowledgeBase({ searchFor: search })
          .$promise
          .then(function (data) {
            vm.is_loading = false
            vm.knowledge_base = data
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, 'Erro ao realizar a pesquisa.')
          })
      }
    }

    function getListTags() {
      KnowledgeBaseService
        .getTagsAutoComplete()
        .$promise
        .then(function (data) {
          vm.tags = data
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao carregar Respostas prontas.')
        })
    }

    vm.autoCompleteOptions = {
      maxItensToRender: 7,
      minimumChars: 2,
      dropdownWidth: 700,
      containerCssClass: 'container-autocomplete',
      dropdownShown: function () {
        vm.autoCompleteOpened = true
      },
      dropdownHidden: function () {
        setTimeout(() => {
          vm.autoCompleteOpened = false
        }, 500)
      },
      renderItem: function (item) {
        var text = UtilsService.jsonParseText(item.text)
        return {
          value: text,
          label: $sce.trustAsHtml(
            "<div title='" + text + "' >" +
            "<span style='font-weight: bold; text-overflow: ellipsis; width: 600x; display: block; overflow: hidden; white-space: nowrap;'>" + item.title + '</span>' +
            "<span style='font-weight: 500; text-overflow: ellipsis; width: 600x; display: block; overflow: hidden; white-space: nowrap;' >" + text + '</span>' +
            '</div>'
          )
        }
      },
      itemSelected: function (event) {
        const { text } = event.item

        if (textHasVariables(text)) {
          NotificationService.warningHandler(
            null,
            $scope.labels.textHasVariables
          )
        }
      },
      data: function (searchText) {
        if (!vm.metadata.allow['knowledgebase'] ||
          vm.getType(vm.selectedUser[vm.sector_id]) === 'facebook' ||
          vm.getType(vm.selectedUser[vm.sector_id]) === 'sms') {
          return
        }

        searchText = searchText.toUpperCase()
        if (searchText[0] === '#') {
          searchText = searchText.substr(1).replace(/[\u0300-\u036f]/g, '')
        } else {
          return
        }
        let tagsFilter = vm.tags.filter(function (tag) {
          return textToFilter(tag).toUpperCase().replace(/[\u0300-\u036f]/g, '').includes(searchText)
        })

        return tagsFilter
      }
    }

    var textToFilter = function (tag) {
      var text = ''
      if (vm.metadata.knowledgebase_scope && vm.metadata.knowledgebase_scope != '') {
        switch (vm.metadata.knowledgebase_scope) {
          case 'tags':
            angular.forEach(tag.knowledge_base_tags, function (tag) {
              text += ' ' + tag.tag
            })
            break
          default:
            text = tag[vm.metadata.knowledgebase_scope]
            break
        }
      } else {
        text = tag.title + ' ' + tag.text
        angular.forEach(tag.knowledge_base_tags, function (tag) {
          text += ' ' + tag.tag
        })
      }
      return text
    }

    vm.backToAttendance = function () {
      vm.show_history = false
      vm.show_hsm = false
      vm.show_knowledge_base = false
    }

    vm.changeActiveHsm = function () {
      var hsmTemplate = ''
      var hsmSelected = vm.hsmSet.find(function (hsm) {
        if (hsm.id == vm.activeWaent.hsm_id) {
          return hsm
        }
      })

      if (hsmSelected != undefined) {
        hsmTemplate = hsmSelected.template
      }

      vm.activeWaent.hsmTemplate = hsmTemplate
    }

    function textHasVariables(text) {
      const regex = /<([\s\S]+?)>/
      return regex.test(text)
    }

    function getType(contact) {
      return vm.channelManager.getType(contact)
    }

    function getChannelType(contact) {
      if (!contact) return undefined
      if (!Object.keys(contact).length) return undefined
      var id = contact.id
      var arr = id.split('_')
      return arr[0]
    }

    function isClassified(sectorId) {
      return vm.selectedUser[sectorId] && (vm.selectedUser[sectorId].class === '1' || vm.selectedUser[sectorId].class === '2')
    }

    function removeClassification() {
      var sectorId = vm.selectedSector.id
      ConversationService
        .removeClassification({
          company_id: vm.operator.company_id,
          sector_id: sectorId,
          user_id: vm.selectedUser[sectorId].id
        }, {})
        .$promise
        .then(function (data) {
          successHandler(data, $scope.labels.classifRemoved)
        })
        .catch(function (error) {
          errorHandler(error, $scope.labels.errorRemoveClassif)
        })
    }

    function dependenceAutoAssign(operatorAssignedId, userRole) {
      if (operatorAssignedId) return false
      if (userRole !== $rootScope.profiles.ROLE_OPERATOR) return false
      if ((parseInt($rootScope.company_metadata.triage) != parseInt($rootScope.TriageModes.OPERATOR)) && parseInt($rootScope.company_metadata.triage) != parseInt($rootScope.TriageModes.BASIC)) return false
      if ($rootScope.company_metadata.allow === undefined || $rootScope.company_metadata.allow === null) return false
      if ($rootScope.company_metadata.allow.auto_assign === undefined || $rootScope.company_metadata.allow.auto_assign === null) return false
      return true
    }

    function canAutoAssign(contactIsAuto, operatorAssignedId) {
      if (!dependenceAutoAssign(operatorAssignedId, $rootScope.user_data.role)) return false
      var auto_assign = $rootScope.company_metadata.allow.auto_assign.enabled === true
      var contact_auto = $rootScope.company_metadata.allow.auto_assign.contact_auto === true
      var canAssign = (contactIsAuto && auto_assign && contact_auto)
      canAssign = canAssign === true ? canAssign : (!contactIsAuto && auto_assign)
      return canAssign
    }

    function selectUser(sector, user) {
      vm.show = false
      vm.show_history = false
      vm.show_hsm = false
      vm.showConfirmModal = false
      vm.statusManuallySet = false
      vm.selectedUser[sector.id] = user
      vm.allow_track_notification = false
      vm.ai_classification = false
      vm.ai_intent = false
      vm.trackContracts = false
      vm.tracknotifications = false
      vm.tracknotification = false
      vm.clicksign_fullname = null
      vm.clicksign_birthdate = null
      vm.newProposal = null
      vm.digital_signature_docs = []
      vm.mailing_campaign = {}
      vm.message_from_webhook = {}
      vm.messageFromHsm = {}
      vm.isTelesqueB2B = false
      vm.sent_telesaque_b2b = false
      vm.isPayrollV2 = false
      vm.sent_payroll_v2 = false

      var msgRef = new Firebase(firebase_url + '/messages/' + vm.operator.company_id)
      msgRef.orderByKey()
      var messages = msgRef.child(user.$id)
      vm.messages[sector.id] = $firebaseArray(messages)

      vm.messages[sector.id].$loaded(function (m) {
        vm.messages[sector.id] = vm.messages[sector.id].sort(orderMessage)
      })

      if (canAutoAssign(vm.selectedUser[sector.id].auto, vm.selectedUser[sector.id].operator_assigned_id)) {
        vm.setOperator(sector.id, vm.operator.id, true)
      }

      ConversationService
        .loadContactMetadata({
          sector_id: vm.sector_id,
          user_id: user.id
        })
        .$promise
        .then(function (data) {
          getCustomerRecurrence()
          var contact_metadata = data
          var numbers = new RegExp(/^[0-9]+$/)
          for (var i = 0; i < contact_metadata.length; i++) {
            if (contact_metadata[i].type == 'text') {
              (vm.content).push(contact_metadata[i])
              if (contact_metadata[i].key == 'cpf' && contact_metadata[i].metadata && !numbers.test(contact_metadata[i].metadata.value)) {
                vm.content[i].metadata = { 'value': '' }
              } else if (contact_metadata[i].key == 'cpf' && contact_metadata[i].metadata && contact_metadata[i].metadata.value.length < 11) {
                while (contact_metadata[i].metadata.value.length < 11 && contact_metadata[i].metadata.value.length != 0) {
                  contact_metadata[i].metadata.value = '0' + contact_metadata[i].metadata.value
                }
                vm.content[i].metadata = { 'value': contact_metadata[i].metadata.value }
              } else if (contact_metadata[i].key == 'clicksign_fullname') {
                vm.clicksign_fullname = contact_metadata[i]
              } else if (contact_metadata[i].key == 'clicksign_birthdate') {
                vm.clicksign_birthdate = contact_metadata[i]
              } else if (contact_metadata[i].key == 'pushoffer' && contact_metadata[i].is_active == 1) {
                loadHistoryMetadataMetaKey(vm.content.slice(-1)[0], user.id, 'push_offer')
              } else if (contact_metadata[i].key == 'wbilling' && contact_metadata[i].is_active == 1) {
                loadHistoryMetadataMetaKey(vm.content.slice(-1)[0], user.id, 'wbilling')
              } else if (contact_metadata[i].key == 'registrationInfo' && contact_metadata[i].is_active == 1) {
                loadHistoryMetadataMetaKey(vm.content.slice(-1)[0], user.id, 'registrationInfo')
              }
            } else if (contact_metadata[i].key == 'notification' && contact_metadata[i].is_active == 1) {
              vm.allow_track_notification = true
            } else if (contact_metadata[i].key == 'ai_classification' && contact_metadata[i].is_active == 1) {
              vm.ai_classification = true
            }
          }

          if (vm.allow_track_notification) {
            checkTrackNotification()
          }
          if (vm.ai_classification) {
            checkAiClassification()
          }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorMess)
        })

      checkMailing()
      checkCampaign()
      checkAnsweredFromWebhook()
      checkHsm()
      getListTags()
      watchIfIsPayrollV2()
      getFormalizationContact()
      loadSectorsTransferByUser()
      watchDigitalSignatureFirebase(user)
      getResponsibleOperators()
      watchIfIsTelesaqueB2b()
      getProtocolNumber()

      EventService
        .fireEvent({
          'eventLabel': 'OPEN_CARD_MONITORING',
          'contactId': vm.selectedUser[vm.sector_id].id
        })
        .$promise
        .then();

      FoundationApi.publish('dlgChatModal', 'open')
    }

    const getProtocolNumber = () => {
      ConversationService
        .getProtocolNumber({
          company_id: vm.operator.company_id,
          contact_id: vm.selectedUser[vm.sector_id].id,
          sector_id: vm.sector_id
        })
        .$promise
        .then(function (response) {
          vm.protocolNumber = response.protocol
        })
        .catch(function (data) {
          NotificationService.warningHandler(data, $scope.labels.errorFetchingProtocolNumber)
        })
    }

    function watchIfIsTelesaqueB2b() {
      if (vm.selectedUser[vm.sector_id]['is_telesaque_b2b']) {
        vm.isTelesqueB2B = true

        if (vm.selectedUser[vm.sector_id]['sent_telesaque_b2b']) {
          vm.sent_telesaque_b2b = true
        } else {
          vm.sent_telesaque_b2b = false
        }
      } else {
        vm.isTelesqueB2B = false
        vm.sent_telesaque_b2b = false
      }
    }

    function watchIfIsPayrollV2() {
      if (vm.selectedUser[vm.sector_id]['is_payroll_v2']) {
        vm.showTabSignature = false
        vm.showTabSignaturePayrollV2 = true
        vm.isPayrollV2 = true

        if (vm.selectedUser[vm.sector_id]['sent_payroll_v2']) {
          vm.sent_payroll_v2 = true
        } else {
          vm.sent_payroll_v2 = false
        }
      } else {
        vm.isTelesqueB2B = false
        vm.sent_payroll_v2 = false
      }
    }

    function getResponsibleOperators() {
      if (vm.users_filter === undefined) {
        loadUsersBySector()
      }

      const OPERATOR_TRIAGE_MODE = 2
      const onlyOwnOperator = $rootScope.company_metadata.allow.only_own_operator || false
      const triage = $rootScope.company_metadata.triage || 0

      if (onlyOwnOperator && onlyOwnOperator.enabled && triage == 2) {
        vm.responsibleOperatorList = vm.users_filter.filter((user) => {
          if (user.id === vm.operator.id) {
            return true
          }
          return false
        })
        return true
      }

      vm.responsibleOperatorList = vm.users_filter.filter((user) => {
        if (user.role <= vm.operator.role) {
          return true
        }
        return false
      })
    }

    function orderMessage(a, b) {
      return (new Date(a.sent_at)) - (new Date(b.sent_at))
    }

    function sendMessage(sector_id) {
      // check if vm.message[sector_id] isn't empty

      var user = vm.selectedUser[sector_id]
      var attachments = {}

      if (vm.attachState == 3) {
        attachments[vm.file_original_name] = vm.file
      }

      if (vm.sending === true || jQuery.trim(vm.message[sector_id]).length == 0) {
        return
      }

      if (vm.metadata.auto_dist && vm.metadata.auto_dist.on &&
        $rootScope.user_data.role == $rootScope.profiles.ROLE_OPERATOR &&
        (!vm.operator_contacts[vm.selectedUser[sector_id].id] ||
          vm.operator_contacts[vm.selectedUser[sector_id].id].contact.operator_assigned_id != $rootScope.user_data.id
        )) {
        NotificationService.warningHandler(false, 'Este atendimento foi transferido para outro operador.')
        return
      }

      if (textHasVariables(vm.message[sector_id])) {
        NotificationService.warningHandler(
          null,
          $scope.labels.textHasVariables
        )
        return
      }

      vm.sending = true;

      if ($rootScope.company_metadata.hasOwnProperty('badWordFilter')
        && $rootScope.company_metadata.badWordFilter) {
        BadwordsConfigService
          .filterMessage({}, {
            "message": vm.message[sector_id],
          })
          .$promise
          .then(function (data) {
            if (data.hasBadWords) {
              NotificationService.warningHandler(data, "Sua mensagem não pôde ser enviada, pois contém as seguintes palavras proibidas: " + data.badWords, 10000)
              saveBadWordData(data);
            } else {
              sendSafeMessage()
            }

          })
          .catch(function (data) {
            NotificationService.errorHandler(data, "Erro ao enviar Mensagem.")
            vm.sending = false;
          });
      } else {
        sendSafeMessage()
      }

      function saveBadWordData(data) {
        BadwordsConfigService
          .saveReportData({}, {
            "badWords": data.badWords,
            "message": vm.message[sector_id],
            "company_id": $rootScope.user_data.company_id,
            "user_id": $rootScope.user_data.id,
            "sector_id": user.sector_id,
            "phone": user.data.contact_phone
          })
          .$promise
          .then(function (data) {
            NotificationService.warningHandler(data, "Essa tentativa foi notificada à supervisão", 10000)
            vm.sending = false;
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, "Erro ao salvar dados.")
            vm.sending = false;
          });
      }

      function sendSafeMessage() {
        ConversationService
          .sendMessage({ user_id: user.id }, {
            'data': user.data,
            'message': vm.message[sector_id],
            'operator_name': vm.operator.display_name,
            'operator_id': vm.operator.id,
            'attachments': attachments
          })
          .$promise
          .then(function (data, status, headers, config) {
            if (data.success && data.success.hasOwnProperty('message')) {
              NotificationService.warningHandler(null, data.success.message)
            } else if (data.warning) {
              NotificationService.warningHandler(null, data.message)
            } else if (!data.success || (data.success.hasOwnProperty('success') && !data.success.sucess)) {
              errorHandler(data, $scope.labels.errorMess)
            } else {
              vm.message[sector_id] = ''
            }
            vm.sending = false
            vm.cancelAttach()
            $timeout(vm.messageEmojiPicker.forceClose, 100)
          })
          .catch(function (data) {
            errorHandler(data, $scope.labels.errorMess)
            vm.sending = false
          }).then(function () {
            vm.sending = false;
          });
      }
    }

    function sendCustomMessage(sector_id, message, vat_info = {}) {
      // check if vm.message[sector_id] isn't empty
      var user = vm.selectedUser[sector_id]
      var attachments = {}

      if (vm.attachState == 3) {
        attachments[vm.file_original_name] = vm.file
      }

      if (vm.sending === true || jQuery.trim(message).length == 0) {
        return
      }

      vm.sending = true
      ConversationService
        .sendMessage({ user_id: user.id }, {
          'data': user.data,
          'message': message,
          'operator_name': vm.operator.display_name,
          'operator_id': vm.operator.id,
          'attachments': attachments,
          'vat_info': vat_info
        })
        .$promise
        .then(function (data, status, headers, config) {
          if (data.success) {
            vm.message[sector_id] = ''
          } else if (data.warning) {
            NotificationService.warningHandler(null, data.message)
          } else {
            errorHandler(data, $scope.labels.errorMess)
          }
          vm.sending = false
          vm.cancelAttach()
          $timeout(vm.messageEmojiPicker.forceClose, 100)
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorMess)
          vm.sending = false
        })
    }

    function sendPoll(sector_id, poll_id) {
      // check if vm.message[sector_id] isn't empty
      var user = vm.selectedUser[sector_id]
      PollService
        .sendPoll({ user_id: user.id }, {
          'poll_id': poll_id,
          'contact_data': user.data,
          'operator_name': vm.operator.display_name
        })
        .$promise
        .then(function (data, status, headers, config) {
          if (data.success) {
            successHandler(data, $scope.labels.researchSent)
          } else {
            if (data.reason) {
              errorHandler(data, data.reason)
            } else {
              errorHandler(data, $scope.labels.errorResearch)
            }
          }
          vm.poll_id = ''
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorResearch)
          vm.sending = false
          vm.poll_id = ''
        })
    }

    vm.showHistory = function (contact_id) {
      if (vm.preventDefaultDigitalSignature) {
        return false
      }
      closeAutomaticAnswersModal()
      vm.show_hsm = false
      vm.show_knowledge_base = false
      vm.show_history = true
      HistoryService
        .findByContactId({ contact_id: contact_id })
        .$promise
        .then(function (data) {
          vm.messagesHistory = data.messages
          vm.is_loading = false
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Não foi possível carregar o histórico.')
        })
    }

    function loadSectorsTransferByUser() {
      SectorService
        .loadSectorsTransferByUser()
        .$promise
        .then(function (data) {
          if (data.length) {
            vm.sectorsTransfer = data
          }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorSectorsOper)
        })
    }

    function loadUsersBySector() {
      SectorService
        .loadUsersBySector({ current_sector: vm.sector_id, role_user: $rootScope.profiles.ROLE_MANAGER })
        .$promise
        .then(function (data) {
          vm.users_filter = data.operators
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao carregar usuários do filtro.')
          vm.sending = false
        })
    }

    function getClass(message) {
      var messageClass = 'right'
      if (message.sender_type == 0) {
        messageClass = 'left'
      }
      return messageClass
    }

    function getMessageHistoryClass(message) {
      return message.sent_by_operator == 1 ? 'right' : 'left'
    }

    function getName(sector_id, message) {
      var name = ''
      if (message.sender_type == 0) {
        if (vm.selectedUser[sector_id]) {
          name = vm.selectedUser[sector_id].name
        }
      } else {
        // message.operator_id;
        name = message.operator_name
      }

      return isEmoticonEnabled(name)
    }

    function getMessageHistoryName(sector_id, message) {
      var name = 'Auto'
      if (message.sent_by_operator == 0) {
        if (vm.selectedUser[sector_id]) {
          name = vm.selectedUser[sector_id].name
        }
      } else {
        if (message.user) {
          name = message.user.name
        }
      }

      return isEmoticonEnabled(name)
    }

    function isEmoticonEnabled(data) {
      if ($rootScope.user_data.settings === null) { return data }
      if ($rootScope.user_data.settings.show_emoticons === undefined || $rootScope.user_data.settings.show_emoticons === true || $rootScope.user_data.settings === null) { return data }
      if ($rootScope.user_data.settings.show_emoticons === false && data !== undefined) { return data.replace(/[\u0100-\uFFFF]/g, '') }
      return data
    }

    function filterFn(contact) {
      var sector_id = vm.sector_id
      if (!vm.selectedUser[sector_id]) return true
      if (contact.phone_number == vm.selectedUser[sector_id].phone_number) {
        return false
      }
      return true
    }
    function triagem(contact) {
      if (!contact) {
        return false
      }
      // 0. Os senhores do castelo tudo veem e tudo sabem.
      if ($rootScope.checkMenuAccess('lord')) { return true; }
      // 1. Todos os operadores e gestores veem tudo
      if (vm.metadata.triage == $rootScope.TriageModes.BASIC) {
        return true
      }
      // 2. Os operadores vêem tudo atribuído à eles e tudo que não está atribuído a ninguém
      if (vm.metadata.triage == $rootScope.TriageModes.OPERATOR) {
        if ($rootScope.user_data.role == $rootScope.profiles.ROLE_MANAGER) { return true }
        if (!contact.operator_assigned_id) { return true }
        if ($rootScope.user_data.role == $rootScope.profiles.ROLE_OPERATOR && $rootScope.user_data.id == contact.operator_assigned_id) { return true }
      }
      // 3. Apenas os gestores vêem tudo, operadores vêem apenas aquilo atribuído à eles
      if (vm.metadata.triage == $rootScope.TriageModes.MANAGER) {
        if ($rootScope.user_data.role == $rootScope.profiles.ROLE_MANAGER) { return true }
        if ($rootScope.user_data.role == $rootScope.profiles.ROLE_OPERATOR && $rootScope.user_data.id == contact.operator_assigned_id) { return true }
      }
      return false
    }

    function filterMetadata(contact) {
      var name_filter = false
      if (vm.nameFilter != '' && contact && contact.name) {
        name_filter = contact.name.toLowerCase().indexOf(vm.nameFilter.toLowerCase()) != -1
      }
      if (vm.getType(contact) == 'whatsapp') {
        return name_filter || (contact.hasOwnProperty('data') && contact.data.hasOwnProperty('contact_phone') && contact.data.contact_phone.trim().toLowerCase().indexOf(vm.nameFilter.trim().toLowerCase()) != -1)
      }
      if (vm.getType(contact) == 'email') {
        return name_filter || (contact.hasOwnProperty('data') && ((contact.data.hasOwnProperty('contact_email') && contact.data.contact_email.trim().toLowerCase().indexOf(vm.nameFilter.trim().toLowerCase()) != -1) || (contact.data.hasOwnProperty('to') && contact.data.to.trim().toLowerCase().indexOf(vm.nameFilter.trim().toLowerCase()) != -1)))
      }
      if (vm.getType(contact) == 'web') {
        return name_filter || (contact.hasOwnProperty('data') && ((contact.data.hasOwnProperty('email') && contact.data.email.trim().toLowerCase().indexOf(vm.nameFilter.trim().toLowerCase()) != -1) || (contact.data.hasOwnProperty('name') && contact.data.name.trim().toLowerCase().indexOf(vm.nameFilter.trim().toLowerCase()) != -1)))
      }
      if (vm.getType(contact) == 'sms') {
        return name_filter || (contact.hasOwnProperty('data') && contact.data.hasOwnProperty('contact_phone') && contact.data.contact_phone.trim().toLowerCase().indexOf(vm.nameFilter.trim().toLowerCase()) != -1)
      }
      if (vm.getType(contact) == 'facebook') {
        var contact_name = contact.name
        if (typeof contact_name === 'undefined') {
          contact_name = ''
        }
        return name_filter || contact_name.trim().toLowerCase().indexOf(vm.nameFilter.trim().toLowerCase()) != -1
      }
      if (vm.channelManager.isSupported(contact)) {
        return vm.channelManager.filterMetadata(contact, name_filter, vm.nameFilter)
      }
      return false
    }

    function filterStatus(contact) {
      var filters = angular.copy(vm.default_filters)
      vm.filters = QueryStringService.getFilters(filters)

      // There is no contact = don't show
      if (!contact) {
        return false
      }
      // Not filtering, Contact at "All" = show
      if (!vm.filters.status && !contact.status) {
        return true
      }
      // Not filtering, Contact at specific Status = don't show
      if (!vm.filters.status && contact.status) {
        return false
      }
      // Contact don't have status = don't show
      if (!contact.status) {
        return false
      }
      // Filtering and Contact.Status = Filter.Status = show
      if (vm.filters['status'].trim() == ('' + contact.status).trim()) {
        return true
      }
      // Default = don't show
      return false
    }

    function errorHandler(data, override_message) {
      var message = $scope.labels.errorTryAgain
      if (override_message) {
        message = override_message
      } else {
        if (data.data && data.data.message) {
          message = data.data.message
        }
      }
      notifSet.addNotification({ title: $scope.labels.error, content: message, autoclose: '3000', color: 'alert' })
    }

    function successHandler(data, override_message) {
      var message = $scope.labels.dataSaved
      if (override_message) {
        message = override_message
      } else {
        if (data && data.data && data.data.message) {
          message = data.data.message
        }
      }
      notifSet.addNotification({ title: $scope.labels.success, content: message, autoclose: '3000', color: 'success' })
    }

    function changeSector(sector) {
      if (sector) { vm.sector_id = sector.id }

      loadUsersBySector()
      vm.setPage(1)
      vm.selectedSector = sector
      ConversationService
        .loadSectorMetadata({ company_id: vm.operator.company_id, sector_id: vm.sector_id })
        .$promise
        .then(function (data) {
          vm.contact_metadata = {}
          angular.forEach(data, function (value, key) {
            if (value.sector_id) {
              value.sector_id == vm.sector_id ? vm.contact_metadata[value.key] = value : ''
            } else {
              if (vm.contact_metadata[value.key]) {
                !vm.contact_metadata[value.sector_id] ? vm.contact_metadata[value.key] = value : ''
              } else {
                vm.contact_metadata[value.key] = value
              }
            }
          })
        })
        .catch(function (error) {
          errorHandler(error, $scope.labels.errorLoadContact)
        })
    }

    function hasMetadata() {
      var obj = vm.contact_metadata
      if (!obj) {
        return false
      }
      if (typeof obj === 'array') {
        return obj.length > 0
      }
      return Object.keys(obj).length > 0
    }

    function displayNumber(number) {
      return number.substr(4)
    }

    function hasActiveChat(number) {
      return vm.selectedUser[vm.sector_id] && vm.selectedUser[vm.sector_id].name
    }

    function confirmStatus(sector_id, status) {
      vm.showConfirmModal = true
      // FoundationApi.publish("confirmStatusModal", "open");
      vm.statusToConfirm = status
      vm.sectorToConfirm = sector_id
    }

    function cancelConfirmStatus(sector_id, status) {
      // FoundationApi.publish("confirmStatusModal", "close");
      vm.showConfirmModal = false
      delete vm.selectedUser[vm.sector_id].status
    }

    function confirmedStatus() {
      vm.setStatus(vm.sectorToConfirm, vm.statusToConfirm)
      delete vm.sectorToConfirm
      delete vm.statusToConfirm
    }

    function setStatus(sector_id, status, old_status) {
      // Confirmar
      vm.statusManuallySet = true

      var check = false; var isStatusValid = true

      angular.forEach(vm.statuses, function (row, key) {
        if (status === '' && parseInt(row.should_close) === 1) {
          vm.selectedUser[sector_id].status = old_status
          isStatusValid = false
          return
        }
        if (parseInt(row.id) === parseInt(status) && parseInt(row.should_close) === 1) {
          check = true
        }
      })

      if (!isStatusValid) {
        return
      }

      if (check) {
        if (!checkRequiredFields(null, status)) {
          vm.selectedUser[sector_id].status = old_status
          return
        }
      }

      var newStatus = status
      var user = vm.selectedUser[sector_id]
      ConversationService
        .setStatus({
          company_id: vm.operator.company_id,
          sector_id: sector_id,
          user_id: user.id
        }, {
          status: status,
          name: user.name,
          contact: user,
          data: (user.data) ? user.data : []
        })
        .$promise
        .then(function (data) {
          if (data.success) {
            FoundationApi.publish('dlgChatModal', 'close')
            successHandler(data, $scope.labels.sucChanStatus)
          } else {
            user.status = old_status
            var err_message = $scope.labels.errorChanStatus
            if (data.message) { err_message = data.message }
            errorHandler(data, err_message)
          }
          vm.show_modal_close_option = false
        }).catch(function (data) {
          errorHandler(data, $scope.labels.errorChanStatus)
        })

      // Cards closed without classification
      if (vm.metadata.force_classification && status == vm.statuses.default_classification_id) {
        ConversationService
          .saveNoClassification({
            company_id: vm.operator.company_id,
            user_id: vm.operator.id,
            contact_id: vm.selectedUser[vm.sector_id].id
          })
          .$promise
          .then(function (data) {
          }).catch(function (data) {
            errorHandler(data, $scope.labels.errorSaveStatusCard)
          })
      }
    }

    function setAnswered(sector_id, answered) {
      if (vm.preventDefaultDigitalSignature) {
        return false
      }
      var user = vm.selectedUser[sector_id]
      ConversationService
        .setAnswered({
          sector_id: sector_id,
          user_id: user.id
        }, {
          answered: answered
        })
        .$promise
        .then(function (data) {
          successHandler(data, $scope.labels.sucChanStatus)
        }).catch(function (data) {
          errorHandler(data, $scope.labels.errorChanStatus)
        })
    }

    function filterMessage(message) {
      const imageDefault = "'" + window.location.origin + baseUrl + '/assets/images/placeholder.jpg' + "'"
      if (!message) { return }
      var matches = message.match(/\[image channel="(.+)" file="(.+)"\]/)
      if (matches) {
        var channel = matches[1]
        var file = matches[2]
        message = '<br><img onerror="this.src=' + imageDefault + '" style="max-width: 50%" src="' + baseUrl + '/channel_media/' + channel + '/' + file + '"  onclick="angular.element(document.querySelector(\'[ng-app=MktzapApp]\')).scope().$$childHead.vm.seeBigPicture(\'' + baseUrl + '/channel_media/' + channel + '/' + file + '\')"/>'
        message = $sce.trustAsHtml(message)
        return message
      }
      var matches = message.match(/\[attachment config_id="(.+)" file="(.+)" name="(.+)"\]/)
      if (matches) {
        var id = matches[1]
        var file = matches[2]
        var name = matches[3]
        if (name.match(/^http/) != null) {
          var swap = file
          file = name
          name = swap
        }
        message = '<a href="' + file + '" target="_blank" >Anexo: ' + name + '</a>'
        message = $sce.trustAsHtml(message)
        return message
      }
      var matches = message.match(/\[attachment config_id="(.+)" name="(.+)" file="(.+)"\]/)
      if (matches) {
        var id = matches[1]
        var name = matches[2]
        var file = matches[3]
        if (name.match(/^http/) != null) {
          var swap = file
          file = name
          name = swap
        }
        message = '<a href="' + file + '" target="_blank" >Anexo: ' + name + '</a>'
        message = $sce.trustAsHtml(message)
        return message
      }
      var matches = message.match(/\[image provider="(.+)" key="(.+)" file="(.+)"\]/)
      if (matches) {
        var provider = matches[1]
        var key = matches[2]
        var file = matches[3]
        if (provider == 's3') {
          message = '<br><img onerror="this.src=' + imageDefault + '" style="max-width: 50%" src="' + file + '"  onclick="angular.element(document.querySelector(\'[ng-app=MktzapApp]\')).scope().$$childHead.vm.seeBigPicture(\'' + file + '\')"/>'
          message = $sce.trustAsHtml(message)
          return message
        }
      }
      var matches = message.match(/\[media type="(.+)" provider="(.+)" key="(.+)" file="(.+)"\]/)
      if (matches) {
        var type = matches[1]
        var provider = matches[2]
        var key = matches[3]
        var file = matches[4]
        if (provider == 's3') {
          if (type == 'image') {
            message = '<br><img onerror="this.src=' + imageDefault + '" style="max-width: 50%" src="' + file + '"  onclick="angular.element(document.querySelector(\'[ng-app=MktzapApp]\')).scope().$$childHead.vm.seeBigPicture(\'' + file + '\')"/>'
          } else if (type == 'video') {
            message = '<br><video controls="" src="' + file + '"></video>'
          } else if (type == 'audio') {
            message = '<br><audio controls="" src="' + file + '"></audio>'
          }
          message = $sce.trustAsHtml(message)
          return message
        }
      }
      return isEmoticonEnabled(sanitizeHtmlTags(message))
    }

    function sanitizeHtmlTags(message) {
      if (!message) { return }

      var matches = message.match(/<(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])>/ig)
      if (matches) {
        for (var i in matches) {
          var ma = matches[i]
          message = message.replace(ma, ma.replace('<', '').replace('>', ''))
        }
      }

      return message
    }

    vm.viewImageSideBySide = function (documents) {
      var styleDocP3 = ''
      var styleDocClient = ''
      if (documents.P3_degree) {
        var r = 'rotate(' + documents.P3_degree + 'deg)'
        styleDocClient = '-moz-transform: ' + r + ';' +
          '-webkit-transform: ' + r + ';' +
          '-o-transform:' + r + ';' +
          '-ms-transform:' + r + ';' +
          'margin-top: 20px, margin-botton: 20px'
      }
      if (documents.cliente_degree) {
        var r = 'rotate(' + documents.cliente_degree + 'deg)'
        styleDocClient = '-moz-transform: ' + r + ';' +
          '-webkit-transform: ' + r + ';' +
          '-o-transform' + r + ';' +
          '-ms-transform' + r + ';' +
          'margin-top: 20px, margin-botton: 20px'
      }
      var html = "<br><br><div class='container-modal'><div class='col-right'>" +
        '<img src="' + documents.cliente + '" style="max-width: 400px; ' + styleDocClient + '"/></div>'

      $rootScope.mediaContent = $sce.trustAsHtml(html)
      angular.element('#image-viewer').show()
    }

    vm.removeUserDocument = function (type) {
      vm.selectedUser[vm.sector_id].documents[type].NOVO = ''
    }

    vm.downloadChat = function () {
      var el = angular.element(document.querySelectorAll('.chat-area-messages')[0])

      var xhr = new XMLHttpRequest()
      xhr.open('POST', apiUrl + '/download-chat')
      xhr.responseType = 'arraybuffer'

      var params = JSON.stringify({ 'html': el.html() })

      xhr.onload = function () {
        if (this.status === 200) {
          var anchor = angular.element('<a/>')
          anchor.css({ display: 'none' }) // Make sure it's not visible
          angular.element(document.body).append(anchor) // Attach to document

          var blob = new Blob([this.response], { type: 'application/pdf' })
          var objectUrl = URL.createObjectURL(blob)
          var filename = $scope.labels.pdfName

          anchor.attr({
            href: objectUrl,
            target: '_blank',
            download: filename
          })[0].click()

          anchor.remove() // Clean it up afterwards
          URL.revokeObjectURL(objectUrl) // Clean memory blob
        } else {
          console.log($scope.labels.errorDownloadPDF)
        }
      }
      xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8')
      xhr.setRequestHeader('Authorization', 'Bearer ' + $rootScope[cookie_name].currentUser.token)
      xhr.send(params)
    }

    vm.downloadCurrentChat = function (contact, template) {
      vm.downloadChat = true
      $http({
        url: apiUrl + '/download-current-chat',
        method: 'POST',
        data: {
          'company_id': vm.operator.company_id,
          'sector_id': contact.sector_id,
          'contact_id': contact.id,
          'contact': contact,
          'blade_template': template
        }
      })
        .then(function ({ data, status, headers, config }) {
          var content = data
          $http({
            url: pdfServiceUrl,
            method: 'POST',
            data: { content: content },
            responseType: 'arraybuffer'
          })
            .then(function ({ data, status, headers, config }) {
              if (data.success === false) {
                NotificationService.errorHandler(data, $scope.labels.errorReport)
                return
              }

              if (data) {
                var filename = $scope.labels.fileName

                var anchor = angular.element('<a/>')
                anchor.css({ display: 'none' }) // Make sure it's not visible
                angular.element(document.body).append(anchor) // Attach to document

                var blob = new Blob([data], { type: 'application/pdf;charset=utf-8' })
                var csvUrl = URL.createObjectURL(blob)

                anchor.attr({
                  href: csvUrl,
                  target: '_self',
                  download: filename
                })[0].click()

                anchor.remove() // Clean it up afterwards
                URL.revokeObjectURL(csvUrl) // Clean memory blob
                vm.downloadChat = false
              } else {
                vm.downloadChat = false
                NotificationService.errorHandler(null, $scope.labels.noData)
              }
            }, function ({ data, status, headers, config }) {
              vm.sending = false
              NotificationService.errorHandler(data, $scope.labels.errorReport)
            })
        }, function ({ data }) { console.log(data) })
    }

    vm.resendEmailAcionaSeguro = function (contact) {
      vm.resendingEmail = true
      ConversationService
        .resendEmailAcionaSeguro({},
          {
            'company_id': vm.operator.company_id,
            'sector_id': contact.sector_id,
            'contact_id': contact.id,
            'contact': contact
          }
        )
        .$promise
        .then(function (data, status, headers, config) {
          successHandler(data, $scope.labels.emailSentAgain)
          vm.resendingEmail = false
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorSendEmail)
          vm.resendingEmail = false
        })
    }

    vm.declineDocumentation = function () {
      vm.sendCustomMessage(vm.sector_id, $scope.labels.differentDate)
    }

    vm.attachState = 0
    function checkAttaching(stage) {
      if (stage) {
        return vm.attachState == stage
      }
      return vm.attachState > 0
    }

    function attach() {
      vm.attachState = 1
    }

    vm.has_unanswered = {}
    function hasUnanswered(sector_id) {
      if (vm.contacts[sector_id]) {
        var total = 0
        var length = vm.contacts[sector_id].length
        for (var i = 0; i < length; ++i) {
          var contact = vm.contacts[sector_id][i]
          var shouldCount = false
          // 0. Os senhores do castelo tudo veem e tudo sabem.
          if ($rootScope.user_data.role == $rootScope.profiles.ROLE_ADMIN) { shouldCount = true }
          // 1. Todos os operadores e gestores veem tudo
          if (vm.metadata.triage == $rootScope.TriageModes.BASIC) {
            shouldCount = true
          }
          // 2. Os operadores vêem tudo atribuído à eles e tudo que não está atribuído a ninguém
          if (vm.metadata.triage == $rootScope.TriageModes.OPERATOR) {
            if ($rootScope.user_data.role == $rootScope.profiles.ROLE_MANAGER) { shouldCount = true }
            if (!contact.operator_assigned_id) { shouldCount = true }
            if ($rootScope.user_data.role == $rootScope.profiles.ROLE_OPERATOR && $rootScope.user_data.id == contact.operator_assigned_id) { shouldCount = true }
          }
          // 3. Apenas os gestores vêem tudo, operadores vêem apenas aquilo atribuído à eles
          if (vm.metadata.triage == $rootScope.TriageModes.MANAGER) {
            if ($rootScope.user_data.role == $rootScope.profiles.ROLE_MANAGER) { shouldCount = true }
            if ($rootScope.user_data.role == $rootScope.profiles.ROLE_OPERATOR && $rootScope.user_data.id == contact.operator_assigned_id) { shouldCount = true }
          }

          var
            not_answered = (!contact.auto || contact.auto == '0') && !contact.answered && !contact.operator_id || (!contact.auto || contact.auto == '0') && !contact.answered && contact.operator_id && vm.triagem(contact)
          var answered = (!contact.auto || contact.auto == '0') && contact.answered
          if (not_answered && shouldCount) {
            ++total
          }
        }
        vm.has_unanswered[sector_id] = total
        return total
      } else {
        return 0
      }
    }
    function isCurrentOperator(operator_id) {
      if (!vm.operator) return false
      return operator_id == vm.operator.id
    }

    // CONVERSATION MODULE
    function setSector(current_sector_id, sector_id) {
      var user = vm.selectedUser[current_sector_id]
      var removeResponsibleOnTransfer = removeResponsibleOnTransferEnabled()
      var newSectorId = sector_id
      vm.changeSector(vm.selectedSector)
      ConversationService
        .setSector({
          user_id: user.id
        }, {
          'contact': user,
          'current_sector_id': current_sector_id,
          'sector_id': sector_id
        })
        .$promise
        .then(function (data, status, headers, config) {
          vm.changeSector(vm.selectedSector)
          if (removeResponsibleOnTransfer) {
            vm.setOperator(vm.selectedSector.id, null, true, newSectorId)
          }
          FoundationApi.publish('dlgChatModal', 'close')
          successHandler(data, $scope.labels.SectorUpdate)
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorChanStatus)
        })
    }
    function setOperator(current_sector_id, operator_id, auto_set, new_sector_id) {
      var user = vm.selectedUser[current_sector_id]
      var sectorId = !new_sector_id ? current_sector_id : new_sector_id
      ConversationService
        .setOperator({
          user_id: user.id
        }, {
          'contact': user,
          'current_sector_id': sectorId,
          'operator_id': operator_id,
          'answered': user.answered
        })
        .$promise
        .then(function (data, status, headers, config) {
          if (!auto_set) {
            successHandler(data, $scope.labels.sucChanOp)
          }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorChanStatus)
        })
    }
    function saveNotes(current_sector_id, show_message = true) {
      var user = vm.selectedUser[current_sector_id]
      ConversationService
        .saveNotes({
          user_id: user.id
        }, {
          'notes': user.notes,
          'current_sector_id': current_sector_id
        })
        .$promise
        .then(function (data, status, headers, config) {
          if (show_message) {
            successHandler(data, $scope.labels.sucChanObs)
          }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorSaveObs)
        })
    }
    function sendAttach() {
      var user = vm.selectedUser[vm.sector_id]

      if (vm.channelManager.isSupported(user)) {
        ConversationService
          .sendAttachment({
            user_id: user.id
          }, {
            'to': user.data.user_id,
            'file_public_path': vm.file,
            'type': vm.file_type,
            'content_type': vm.content_type,
            'file': vm.file_name,
            'name': vm.file_original_name,
            'data': user.data,
            'operator_name': vm.operator.display_name,
            'operator_id': vm.operator.id
          })
          .$promise
          .then(function (data, status, headers, config) {
            vm.attachState = 0
            vm.current_progress = 0
            vm.file = null
            vm.file_name = null
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, $scope.labels.errorSendAttac)
          })
      } else {
        ConversationService
          .sendAttachment({
            user_id: user.id
          }, {
            'to': user.data.contact_phone,
            'file_public_path': vm.file,
            'type': vm.file_type,
            'content_type': vm.content_type,
            'file': vm.file_name,
            'name': vm.file_original_name,
            'data': user.data,
            'operator_name': vm.operator.display_name,
            'operator_id': vm.operator.id
          })
          .$promise
          .then(function (data, status, headers, config) {
            if (data.warning) {
              NotificationService.warningHandler(null, data.message)
            }
            vm.attachState = 0
            vm.current_progress = 0
            vm.file = null
            vm.file_name = null
          })
          .catch(function (data) {
            errorHandler(data, $scope.labels.errorSendAttac)
          })
      }
    }

    function resetNotes(current_sector_id) {
    }

    function getCustomerRecurrence() {
      HistoryService
        .customerRecurrence(
          { contact_id: vm.selectedUser[vm.sector_id].id },
          { sector_id: vm.sector_id }
        )
        .$promise.then(function (data) {
          vm.customer_recurrence = data
        })
    }

    function cancelAttach() {
      vm.attachState = 0
    }
    function upload(file) {
      if (!file) {
        return NotificationService.warningHandler("", "O arquivo ultrapassa o limite permitido " + vm.fileMaxSize);
      }
      vm.fileUpload = file;
      var user = vm.selectedUser[vm.sector_id]
      var data = {}
      if (vm.getType(user) == 'whatsapp' || vm.getType(user) == 'waent') {
        var channel_type = vm.getChannelType(user)
        data = {
          url: baseUrl + '/upload-attachment-whatsapp',
          fields: { 'channel_id': user.data.channel_id, channel_type: channel_type },
          file: file
        }
      } else if (vm.getType(user) == 'email') {
        var channel_type = vm.getChannelType(user)
        data = {
          url: baseUrl + '/upload-attachment-mail',
          fields: { 'email_config_id': user.data.email_config_id, channel_type: channel_type },
          file: file
        }
      } else if (vm.getType(user) == 'facebook') {
        var channel_type = vm.getChannelType(user)
        data = {
          url: baseUrl + '/upload-attachment-facebook',
          fields: { 'page_id': user.data.page_id, channel_type: channel_type },
          file: file
        }
      } else if (vm.channelManager.isSupported(user)) {
        var channel_type = vm.getChannelType(user)
        data = {
          url: baseUrl + '/upload-attachment-channels',
          fields: { 'contact_id': user.id },
          file: file
        }
      }
      vm.attachState = 2
      vm.current_progress = 0
      Upload.upload(data)
        .progress(function (evt) {
          var progressPercentage = parseInt(100.0 * evt.loaded / evt.total)
          vm.current_progress = progressPercentage
        })
        .then(function (response, status, headers, config) {
          if (response.data && response.data.success == false) {
            vm.attachState = 0;
            return NotificationService.warningHandler("", "Erro ao salvar o arquivo.");
          }
          vm.attachState = 3
          vm.file = response.data.url
          vm.file_name = response.data.file
          vm.content_type = response.data.content_type ? response.data.content_type : ''
          vm.file_original_name = file.name
          if (vm.getType(user) == 'facebook') {
            var matches = response.data.type.match(/(image)\/.*/)
            if (matches) {
              vm.file_type = matches[1]
            }
            var matches = response.data.type.match(/(application)\/.*/)
            if (matches) {
              vm.file_type = matches[1]
            }
            var matches = response.data.type.match(/(video)\/.*/)
            if (matches) {
              vm.file_type = matches[1]
            }
          } else {
            vm.file_type = response.data.type
          }
        }).catch(function (data) {
          errorHandler(data, $scope.labels.errorUpAttac)
        })
    };
    vm.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src)
    }
    FoundationApi.subscribe('dlgChatModal', function (event) {
      if (event == 'close') {
        cleanupChatModal()
      }
    })
    var animate = FoundationApi.animate
    FoundationApi.animate = function () {
      if (arguments[0].prop('id') == 'dlgChatModal' && arguments[1] == false) {
        cleanupChatModal()
      }
      animate.apply(this, Array.prototype.slice.call(arguments, 0))
    }

    function cleanupChatModal() {
      vm.content = []
      vm.customer_recurrence = 0
      vm.selectedUser[vm.sector_id] = {}
      vm.cancelAttach()
    }

    vm.validateBeforeClose = function () {
      vm.protocolNumber = null

      vm.closeRecording();
      unwatchClick()
      unwatchDigitalSignatureFirebase()
      closeAutomaticAnswersModal()
      if (!vm.selectedUser[vm.sector_id].status && vm.metadata.force_classification && vm.statuses.default_classification_id && !$rootScope.checkMenuAccess('lord')) {
        vm.show_modal_close_option = true
      } else {
        FoundationApi.publish('dlgChatModal', 'close')
      }
      $timeout(vm.messageEmojiPicker.forceClose, 100)
    }

    function getUserPhone() {
      var phone
      if (vm.selectedUser[vm.sector_id].data.contact_phone) {
        phone = vm.selectedUser[vm.sector_id].data.contact_phone
        if (phone.length != 11) { // com o identificador do país
          phone = (vm.selectedUser[vm.sector_id].data.contact_phone).substring(2)
        }
      }
      return phone
    }

    function checkTrackNotification() {
      var phone = getUserPhone()
      var email = vm.selectedUser[vm.sector_id].data.contact_email
      var contact_id = vm.selectedUser[vm.sector_id].id

      if ((phone || email) && contact_id) {
        TrackNotificationService
          .getTrackData({
            phone: phone,
            email: email,
            contact_id: contact_id
          }, {})
          .$promise
          .then(function (data) {
            if (data.contracts) {
              vm.trackContracts = data.contracts
              vm.trackKeys = data.keys
              vm.selectedContractId = data.contracts[0].id
              vm.selectedContractName = data.contracts[0].name
              vm.selectedKey = data.keys[vm.selectedContractId][0]
              vm.trackEmissions = data.emissions
              vm.selectedEmissions = vm.trackEmissions[vm.selectedContractId]

              vm.trackClients = data.clients
              vm.trackTypes = data.types
              vm.trackTransportadoras = data.transportadoras
              vm.trackRastreios = data.rastreios
              vm.trackCadeias = data.cadeias
              vm.trackLojas = data.lojas
              vm.trackNomesSeguro = data.nomes_seguro

              vm.selectedClient = vm.trackClients[vm.selectedContractId]
              vm.selectedType = vm.trackTypes[vm.selectedContractId]
              vm.selectedCadeia = vm.trackCadeias[vm.selectedContractId][vm.selectedKey]
              vm.selectedLoja = vm.trackLojas[vm.selectedContractId]
              vm.selectedNomeSeguro = vm.trackNomesSeguro[vm.selectedContractId]
              if (vm.trackTransportadoras[vm.selectedContractId]) {
                vm.selectedTransportadora = vm.trackTransportadoras[vm.selectedContractId][vm.selectedKey]
              }
              vm.selectedRastreio = ''
              if (vm.trackRastreios[vm.selectedContractId]) {
                vm.selectedRastreio = vm.trackRastreios[vm.selectedContractId][vm.selectedKey]
              }

              vm.tracknotifications = data.result
              vm.tracknotification = data.result[vm.selectedContractId][vm.selectedKey]
              vm.selectedUser[vm.sector_id].notes = vm.selectedCadeia
              saveNotes(vm.sector_id, false)

              for (var i = 0; i < vm.content.length; i++) {
                if (vm.content[i].key == 'cpf') {
                  while (data.cpf.length < 11 && data.cpf.length != 0) {
                    data.cpf = '0' + data.cpf
                  }
                  if (!vm.content[i].metadata) {
                    vm.content[i].metadata = { 'value': data.cpf }
                  } else {
                    vm.content[i].metadata.value = data.cpf
                  }
                } else if (vm.content[i].key == 'nrm') {
                  if (!vm.content[i].metadata) {
                    vm.content[i].metadata = { 'value': vm.selectedContractId }
                  } else {
                    vm.content[i].metadata.value = vm.selectedContractId
                  }
                } else if (vm.content[i].key == 'tracking_number') {
                  if (!vm.content[i].metadata) {
                    vm.content[i].metadata = { 'value': vm.selectedRastreio }
                  } else {
                    vm.content[i].metadata.value = vm.selectedRastreio
                  }
                  updateKey(vm.content[i].metadata, vm.content[i], false)
                }
              }
            } else {
              vm.tracknotification = false
            }
          })
          .catch(function (error) {
            vm.tracknotification = false
          })
      }
    }

    function selectContract(saveTrackerInfos = true, selectedKey = false) {
      var select = document.getElementById('select_contract')
      var contact_id = vm.selectedUser[vm.sector_id].id

      vm.selectedContractId = select.options[select.selectedIndex].id

      if (selectedKey) {
        vm.selectedKey = selectedKey
      } else {
        vm.selectedKey = vm.trackKeys[vm.selectedContractId][0]
      }
      vm.selectedClient = vm.trackClients[vm.selectedContractId]
      vm.selectedType = vm.trackTypes[vm.selectedContractId]
      vm.selectedCadeia = vm.trackCadeias[vm.selectedContractId][vm.selectedKey]
      vm.selectedLoja = vm.trackLojas[vm.selectedContractId]
      vm.selectedNomeSeguro = vm.trackNomesSeguro[vm.selectedContractId]
      vm.tracknotification = vm.tracknotifications[vm.selectedContractId][vm.selectedKey]
      vm.selectedEmissions = vm.trackEmissions[vm.selectedContractId]

      if (vm.trackTransportadoras[vm.selectedContractId]) {
        vm.selectedTransportadora = vm.trackTransportadoras[vm.selectedContractId][vm.selectedKey]
      }

      vm.selectedRastreio = ''
      if (vm.trackRastreios[vm.selectedContractId]) {
        vm.selectedRastreio = vm.trackRastreios[vm.selectedContractId][vm.selectedKey]
      }

      for (var i = 0; i < vm.content.length; i++) {
        if (vm.content[i].key == 'tracking_number' && vm.content[i].metadata) {
          vm.content[i].metadata.value = vm.selectedRastreio
          updateKey(vm.content[i].metadata, vm.content[i], false)
        }
      }

      if (saveTrackerInfos) {
        vm.selectedUser[vm.sector_id].notes = vm.selectedCadeia
        saveNotes(vm.sector_id, false)

        TrackNotificationService
          .saveContract({
            contact_id: contact_id,
            contract: vm.selectedContractId
          }, {})
          .$promise
          .then(function (data) {
            for (var i = 0; i < vm.content.length; i++) {
              if (vm.content[i].key == 'nrm' && vm.content[i].metadata) {
                vm.content[i].metadata.value = vm.selectedContractId
              }
            }
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $scope.labels.errorContractNum)
          })
      }
    }

    function registerDelivery() {
      var phone = getUserPhone()
      var email = vm.selectedUser[vm.sector_id].data.contact_email

      if (phone || email) {
        TrackNotificationService
          .registerDelivery({
            phone: phone,
            email: email,
            contract: vm.selectedContractId
          }, {})
          .$promise
          .then(function (data) {
            checkTrackNotification()
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, $scope.labels.errorDelivery)
          })
      }
    }

    /** formalization */

    function getFormalizationContact() {
      DigitalSignService
        .getContactsByFilters({
          contactId: vm.selectedUser[vm.sector_id].id
        })
        .$promise
        .then(function (data) {
          if (data.success) {
            vm.proposals = data.contact.propostas
            vm.formalizationContact = data.contact
            vm.checkResend = checkResend()
            return true
          }
          vm.proposals = []
          vm.formalizationContact = []
        }).catch(function () {
          vm.proposals = []
          vm.formalizationContact = []
        })
    }

    vm.switchTab = function (tab) {
      if (vm.preventDefaultDigitalSignature) {
        return false
      }
      if (tab == 'signatures') {
        vm.isPayrollV2 ? vm.showTabSignaturePayrollV2 = true : vm.showTabSignature = true
        vm.showTabDocuments = false
        unwatchChanges()
      } else {
        vm.isPayrollV2 ? vm.showTabSignaturePayrollV2 = false : vm.showTabSignature = false
        vm.showTabDocuments = true
        watchChanges()
      }
    }

    vm.openPopover = function (status) {
      if (!validateProposal(vm.newProposal)) {
        vm.popover = false
        return
      }
      if (status && vm.popover) {
        vm.popover = false
        return
      }
      vm.popover = true
    }

    vm.callUploadProposalButton = function () {
      if (!validateProposal(vm.newProposal)) {
        vm.popover = false
        return false
      }
      angular.element('#btn-upload-proposal').triggerHandler('click')
      return true
    }

    function validateProposal(proposal) {
      if (!proposal) {
        NotificationService.warningHandler('', 'É necessário inserir uma proposta')
        return false
      }
      if (proposal.length < 13) {
        NotificationService.warningHandler('', 'A proposta deve ter 13 caracteres')
        return false
      }
      for (let index = 0; index < vm.proposals.length; index++) {
        if (vm.proposals[index].number === parseInt(proposal)) {
          NotificationService.warningHandler('', 'Proposta já existe: ' + proposal)
          return false
        }
      }
      return true
    }

    vm.uploadContracts = function (contracts) {
      let contractUpload = []
      if (contracts) {
        angular.forEach(contracts, function (file, key) {
          Upload.upload({
            url: apiUrl + '/upload-ccb',
            data: {
              'contact_id': vm.selectedUser[vm.sector_id].id,
              'company_id': vm.operator.company_id,
              'proposal_number': parseInt(vm.newProposal),
              'isPayrollV2': vm.isPayrollV2
            },
            file: file
          })
            .then(function (data) {
              if (data.data.public_path) {
                contractUpload.push(data.data.public_path)
                if (contracts.length === contractUpload.length) {
                  addNewProposal(contractUpload).then(() => {
                    scrollToBottom()
                  })
                }
                NotificationService.successHandler(data, 'Upload de documento realizado com sucesso')
              } else {
                NotificationService.errorHandler(data, 'Erro ao realizar upload de documento')
              }
              vm.popover = false
            }).catch(function (data) {
              NotificationService.errorHandler(data, 'Erro ao realizar upload de documento')
              vm.popover = false
            })
        })
      }
    }

    function addNewProposal(contractUpload) {
      return new Promise((resolve) => {
        const newData = {
          ccb: contractUpload || null,
          number: String(vm.newProposal),
          signed: false,
          send_counter: 0
        }
        vm.proposals.push(newData)
        vm.newProposal = null
        resolve('success')
      })
    }

    vm.addNewProposalButton = () => {
      if (!validateProposal(vm.newProposal)) {
        return false
      }
      const newData = {
        ccb: null,
        number: String(vm.newProposal),
        signed: false,
        send_counter: 0
      }
      vm.proposals.push(newData)
      vm.newProposal = null
    }

    function scrollToBottom() {
      const scrollingElement = angular.element('#div-proposal-list')[0]
      scrollingElement.scrollTop = scrollingElement.scrollHeight
    }

    vm.downloadUploadFiles = function (files) {
      if (files == 'error') {
        NotificationService.warningHandler('', 'Não foi possível abrir os anexos, favor inserir manualmente')
        return false
      }
      if (typeof (files) === 'object') {
        angular.forEach(files, function (url) {
          downloadByUrl(url)
        })
      } else {
        downloadByUrl(files)
      }
    }

    function downloadByUrl(url) {
      const anchor = angular.element('<a/>')
      anchor.css({
        display: 'none'
      })
      angular.element(document.body).append(anchor)
      anchor.attr({
        href: url,
        target: '_blank'
      })[0].click()
      anchor.remove()
    }

    vm.removeProposal = function (proposalNumber, proposal) {
      if (proposal.upload_by_job || proposal.signature_error) {
        DigitalSignService.deleteContactProposal({
          proposal: proposalNumber,
          contactId: vm.selectedUser[vm.sector_id].id,
          sectorId: vm.sector_id
        })
          .$promise
          .then(function (data) {
            if (!data.success) {
              NotificationService.warningHandler(data, 'Não foi possível remover a proposta')
              return false
            }
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, 'Erro ao remover proposta')
            return false
          })
      }
      for (let index = 0; index < vm.proposals.length; index++) {
        if (vm.proposals[index].number === proposalNumber) {
          vm.proposals.splice(index, 1)
        }
      }
      NotificationService.successHandler(null, 'Proposta removida com successo')
    }

    function disableButtonRemove(proposalNumber) {
      vm.proposals.forEach((element, key) => {
        if (proposalNumber == element.number) {
          vm.proposals[key].uploadDocument = true
        }
      })
    }

    vm.searchContracts = function () {
      if (!validateProposal(vm.newProposal)) {
        vm.popover = false
        return false
      }
      vm.isLoading = true
      DigitalSignService.getDocumentList({
        proposal: vm.newProposal
      })
        .$promise
        .then(function (data) {
          if (data.success) {
            vm.documentList = data.result
            selectAllDocuments()
            FoundationApi.publish('dlgDocsSearchApiPayroll', 'open')
          } else {
            NotificationService.warningHandler(data, data.message || 'Houve um problema ao localizar a proposta')
          }
          vm.isLoading = false
          vm.popover = false
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, data.message)
          vm.isLoading = false
          vm.popover = false
        })
    }

    function selectAllDocuments() {
      Object.values(vm.documentList).forEach((document) => {
        if (vm.documentList.upload) {
          vm.documentList.upload[document.name] = true
        } else {
          vm.documentList.upload = []
          vm.documentList.upload[document.name] = true
        }
      })
    }

    function filterByChecked(payload) {
      Object.entries(payload).forEach(([key, value]) => {
        if (Object.keys(payload).length !== 0 && !value) {
          delete payload[key]
        }
      })
      return payload
    }

    vm.generateDocumentBySubscription = function () {
      vm.documentList.upload = filterByChecked(vm.documentList.upload)
      let proposalNumber = vm.newProposal

      DigitalSignService.generateDocumentBySubscription({
        proposal: proposalNumber,
        contactId: vm.selectedUser[vm.sector_id].id,
        sectorId: vm.sector_id,
        documents: Object.assign({}, vm.documentList.upload)
      })
        .$promise
        .then(function (data) {
          if (data.success) {
            if (Object.keys(vm.documentList.upload).length === 0) {
              FoundationApi.publish('dlgDocsSearchApiPayroll', 'close')
              NotificationService.warningHandler(null, 'Nenhum documento foi selecionado')
            } else {
              FoundationApi.publish('dlgDocsSearchApiPayroll', 'close')
              NotificationService.successHandler(null, 'Aguarde, os documentos estão sendo adicionados...')
              addNewProposal().then(() => {
                scrollToBottom()
                disableButtonRemove(proposalNumber)
              })
            }
            vm.popover = false
          }
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, data.message)
          vm.popover = false
        })
    }

    function prepareProposalsNumber() {
      let proposalsNumber = []
      vm.proposals.forEach(element => {
        if (vm.openProposals[element.number] && element.ccb && !element.signed_ccb) {
          proposalsNumber.push(element.number)
        }
      })
      return proposalsNumber
    }

    function prepareProposalsNumberForPayrollV2() {
      let proposalsNumber = []
      vm.proposals.forEach(element => {
        if (vm.openProposals[element.number] && !element.signed_ccb) {
          proposalsNumber.push(element.number)
        }
      })
      return proposalsNumber
    }

    function prepareProposalsPath() {
      let proposalsPath = []
      vm.proposals.forEach(element => {
        if (vm.openProposals[element.number] && element.ccb == 'error') {
          vm.wrongProposal = element.number
        }
        if (vm.openProposals[element.number] && element.ccb && !element.signed_ccb && element.ccb != 'error') {
          proposalsPath[element.number] = element.ccb
        }
      })
      return proposalsPath
    }

    function validateCustomerFields() {
      if (!vm.formalizationContact.name) {
        NotificationService.warningHandler('', 'Favor inserir o nome do cliente')
        return false
      }
      if (!vm.formalizationContact.cpf) {
        NotificationService.warningHandler('', 'Favor inserir um CPF')
        return false
      }
      return true
    }

    function checkResendCount(proposalsNumbers) {
      if ($rootScope.checkMenuAccess('digitalSignature.unlimitedResend')) {
        return true
      }

      // eslint-disable-next-line semi
      const limit = $rootScope.company_metadata.max_formalization_send_quantity;

      if (limit === undefined) {
        return true
      }

      for (let i = 0; i < proposalsNumbers.length; i++) {
        const proposalNumber = proposalsNumbers[i]
        for (let j = 0; j < vm.proposals.length; j++) {
          const proposal = vm.proposals[j]
          if (proposalNumber == proposal.number && proposal.send_counter >= limit) {
            NotificationService.warningHandler('', 'As tentativas de reenvio do link foram esgotadas para a proposta: ' + proposal.number +
              ', gentileza verificar junto ao cliente se o telefone do mesmo é ativo para recebimento de SMS')
            return false
          }
        }
      }
      return true
    }

    function setSignedProposals(proposalsNumber) {
      if (vm.checkResend) {
        saveResendSms(proposalsNumber)
      }

      vm.proposals.forEach((element, key) => {
        if (proposalsNumber.indexOf(element.number) !== -1) {
          vm.proposals[key].signed = true
        }
      })
      vm.checkResend = true
    }

    function setSentSms(proposalsNumber) {
      vm.proposals.forEach((element, key) => {
        if (proposalsNumber.indexOf(element.number) !== -1) {
          if (!vm.proposals[key].send_counter) {
            vm.proposals[key].send_counter = 0
          }
          vm.proposals[key].send_counter++
        }
      })
    }

    function addMaskDate(date) {
      if (date) {
        return date.replace(/^([\d]{2})([\d]{2})([\d]{4})$/, '$1/$2/$3')
      }
      return date
    }

    function saveResendSms(proposalsNumber) {
      let proposals

      proposalsNumber.forEach(proposal => {
        if (!proposals) {
          proposals = proposal
        } else {
          proposals += '-' + proposal
        }
      })

      DigitalSignService
        .saveResendSms({
          contact_id: vm.formalizationContact.contact_id || vm.selectedUser[vm.sector_id].id,
          proposal: proposals
        })
    }

    vm.approveProposals = function () {
      vm.wrongProposal = false

      vm.openProposals = filterByChecked(vm.openProposals)

      const proposalsNumber = prepareProposalsNumber()

      if (!proposalsNumber.length) {
        NotificationService.warningHandler(null, 'Nenhuma proposta foi selecionada')
        return false
      }

      const checkResend = checkResendCount(proposalsNumber)

      if (!checkResend) {
        vm.closeModalApproveAll()
        return false
      }

      const proposalsPath = prepareProposalsPath()

      if (proposalsNumber.length != proposalsPath.length && vm.wrongProposal) {
        NotificationService.warningHandler('', 'Ocorreu um erro ao inserir os documento(s) da proposta:' +
          vm.wrongProposal + ' Por favor, insira novamente!')
        vm.closeModalApproveAll()
        return false
      }

      const valid = validateCustomerFields()

      if (!valid) {
        vm.closeModalApproveAll()
        return false
      }

      setSignedProposals(proposalsNumber)
      setSentSms(proposalsNumber)

      const payload = {
        proposals_numbers: Object.assign({}, proposalsNumber),
        proposals_paths: Object.assign({}, proposalsPath),
        contact_email: vm.formalizationContact.email || null,
        cpf: vm.formalizationContact.cpf || null,
        data_nasc: addMaskDate(vm.formalizationContact.birthdate) || null,
        full_name: vm.formalizationContact.name || null,
        phone: vm.selectedUser[vm.sector_id].data.contact_phone,
        contact_id: vm.formalizationContact.contact_id || vm.selectedUser[vm.sector_id].id,
        sector_id: vm.sector_id,
        channel_id: vm.selectedUser[vm.sector_id].data.channel_id,
        proposals: vm.proposals,
        is_payroll_v2: vm.isPayrollV2
      }

      DigitalSignService.approveProposal(payload)
        .$promise
        .then(function (data) {
          if (data.success) {
            NotificationService.successHandler('', 'Proposta(s) enviada(s) para assinatura')
          } else {
            NotificationService.successHandler(data, data.message)
          }
          vm.closeModalApproveAll()
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao enviar proposta(s)')
          vm.closeModalApproveAll()
        })
    }

    vm.sendProposals = () => {
      vm.openProposals = filterByChecked(vm.openProposals)

      const proposalsNumber = prepareProposalsNumberForPayrollV2()

      if (!proposalsNumber.length) {
        NotificationService.warningHandler(null, 'Nenhuma proposta foi selecionada')
        return false
      }

      const checkResend = checkResendCount(proposalsNumber)

      if (!checkResend) {
        vm.closeModalApproveAll()
        return false
      }

      const valid = validateCustomerFields()

      if (!valid) {
        vm.closeModalApproveAll()
        return false
      }

      setSignedProposals(proposalsNumber)
      setSentSms(proposalsNumber)

      const payload = {
        proposals_numbers: Object.assign({}, proposalsNumber),
        contact_email: vm.formalizationContact.email || null,
        cpf: vm.formalizationContact.cpf || null,
        data_nasc: addMaskDate(vm.formalizationContact.birthdate) || null,
        full_name: vm.formalizationContact.name || null,
        phone: vm.selectedUser[vm.sector_id].data.contact_phone,
        contact_id: vm.formalizationContact.contact_id || vm.selectedUser[vm.sector_id].id,
        sector_id: vm.sector_id,
        channel_id: vm.selectedUser[vm.sector_id].data.channel_id,
        proposals: vm.proposals,
        selected_user: vm.selectedUser[vm.sector_id],
        is_payroll_v2: vm.isPayrollV2
      }

      DigitalSignService.approveProposalPayrollV2(payload)
        .$promise
        .then(function (data) {
          if (data.success) {
            NotificationService.successHandler('', 'Proposta(s) enviada(s) para assinatura')
          } else {
            NotificationService.warningHandler(data, data.message)
          }
          vm.closeModalApproveAll()
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao enviar proposta(s)')
          vm.closeModalApproveAll()
        })
    }

    vm.openModalApproveAll = function () {
      vm.openProposals = []

      vm.proposals.forEach(proposal => {
        if (proposal.ccb && !proposal.signed_ccb) {
          vm.openProposals.push(proposal.number)
          vm.openProposals[proposal.number] = true
        }
      })

      if (vm.isPayrollV2) {
        vm.proposals.forEach(proposal => {
          if (!proposal.signed_ccb) {
            vm.openProposals.push(proposal.number)
            vm.openProposals[proposal.number] = true
          }
        })
      }

      if (!vm.openProposals.length) {
        NotificationService.warningHandler('', 'Não há contratos para serem enviados')
        return false
      }

      FoundationApi.publish('confirmationModal', 'open')
      return true
    }

    vm.closeModalApproveAll = function () {
      FoundationApi.publish('confirmationModal', 'close')
    }

    vm.approveDocuments = function () {
      const payload = {
        contact_id: vm.selectedUser[vm.sector_id].id
      }

      DigitalSignService.approveDocuments(payload)
        .$promise
        .then(function (data) {
          if (!data.success) {
            NotificationService.warningHandler(data, data.message)
            return
          }
          NotificationService.successHandler('', 'Documento(s) aprovado(s)')
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, 'Erro ao aprovar documento(s)')
        })
    }

    vm.seeBigPicture = function (image) {
      vm.bigPicture = image || null
      FoundationApi.publish('big-picture', 'open')
    }

    vm.closeBigPicture = function () {
      vm.elementDegree = 0
      FoundationApi.publish('big-picture', 'close')
    }

    vm.updateDocumentsInfo = function () {
      const payload = {
        fields: {
          name: vm.formalizationContact.name,
          birthdate: vm.formalizationContact.birthdate,
          cpf: vm.formalizationContact.cpf,
          email: vm.formalizationContact.email
        },
        contactId: vm.selectedUser[vm.sector_id].id,
        sectorId: vm.sector_id
      }
      DigitalSignService.updateDocumentsInfo(payload)
        .$promise
        .then(function (data) {
          successHandler(data, 'Documentos salvos com sucesso.')
        })
        .catch(function (data) {
          errorHandler(data, 'Error ao atualizar ' + type)
        })
      unwatchClick()
    }

    function checkResend() {
      for (let index = 0; index < vm.proposals.length; index++) {
        if (vm.proposals[index].signed) {
          return true
        }
      }
      return false
    }

    function mergeFormalizationContactRealTime(contact) {
      if (vm.formalizationContact && vm.formalizationContact.contact_id &&
        (vm.formalizationContact.contact_id == contact.contact_id)) {
        const digitalSignatureContact = contact.digital_signature

        const proposalsFireBase = digitalSignatureContact.proposals || null
        const documentsFireBase = digitalSignatureContact.documents || []

        if (proposalsFireBase) {
          mergeFormalizationProposals(proposalsFireBase)
        }
        mergeFormalizationDocuments(documentsFireBase)
      }
    }

    function mergeFormalizationProposals(proposalsFireBase) {
      if (!vm.proposals) {
        return false
      }

      if (!vm.proposals.length) {
        vm.proposals = [...Object.values(proposalsFireBase)]
        return true
      }
      vm.proposals.forEach((proposal, proposalIndex) => {
        if (proposalsFireBase[proposal.number] && proposal.number == proposalsFireBase[proposal.number].number) {
          vm.proposals[proposalIndex] = proposalsFireBase[proposal.number] || proposal
        }
      })
      return true
    }

    function mergeFormalizationDocuments(documentsFireBase) {
      if (vm.formalizationContact) {
        vm.formalizationContact.documents = documentsFireBase
      }
    }

    vm.rotateElement = (elementId, direction) => {
      let rotate = vm.elementDegree
      if (direction == 'left') {
        rotate -= 90
      } else {
        rotate += 90
      }

      vm.elementDegree = rotate
      const element = angular.element(elementId)
      const r = 'rotate(' + rotate + 'deg)'

      element.css({
        '-moz-transform': r,
        '-webkit-transform': r,
        '-o-transform': r,
        '-ms-transform': r
      })
    }

    vm.resubmitProposal = (proposalNumber) => {
      DigitalSignService.sendDocumentsAgain({
        proposta: proposalNumber,
        sector_id: vm.sector_id,
        contact_id: vm.formalizationContact.contact_id,
        company_id: vm.operator.company_id
      })
        .$promise
        .then(function (data) {
          if (data.success) {
            successHandler(data, $scope.labels.docSendingAgain)
          } else {
            errorHandler(data, $scope.labels.errorDocSendingAgain)
          }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorDocSendingAgain)
        })
    }

    // unsaved-changes START

    function watchChanges() {
      angular.element('.formalization-container').on('change', () => {
        const regexPattern = RegExp('digital-signature-documents')
        vm.preventDefaultDigitalSignature = true
        if (!vm.hasUnsavedChanges) {
          angular.element('.grid-block.vertical.body-attendance').on('click', validateChange(regexPattern))
          vm.hasUnsavedChanges = true
        }
      })
    }

    function unwatchClick() {
      vm.preventDefaultDigitalSignature = false
      vm.hasUnsavedChanges = false
      angular.element('.grid-block.vertical.body-attendance').off('click')
    }

    function unwatchChanges() {
      angular.element('.formalization-container').off('change')
    }

    function validateChange(regexPattern) {
      return (e) => {
        let elemId = e.target.id
        if (!regexPattern.exec(elemId)) {
          e.preventDefault()
          e.stopPropagation()
          FoundationApi.publish('confirmModal', 'open')
        }
      }
    }

    vm.confirmModal = () => {
      vm.updateDocumentsInfo()
      FoundationApi.publish('confirmModal', 'close')
    }

    vm.closeConfirmModal = () => {
      FoundationApi.publish('confirmModal', 'close')
      unwatchClick()
    }
    // unsaved-changes END

    vm.downloadCustomDocument = function () {
      const contactId = vm.selectedUser[vm.sector_id].id
      CustomDocumentsService
        .download({
          contact_id: contactId
        })
        .$promise
        .then(function (data) {
          if (data.success) {
            downloadByUrl(data.documentUrl)
          } else {
            NotificationService.errorHandler(data, data.message)
          }
        })
        .catch(function (error) {
          errorHandler(error, $scope.labels.errorDownloadCustomDoc)
        })
    }

    function unwatchDigitalSignatureFirebase() {
      vm.digitalSignatureFirebase.off('child_added')
      vm.digitalSignatureFirebase.off('child_changed')
    }

    function watchDigitalSignatureFirebase(user) {
      vm.digitalSignatureFirebase = new Firebase(firebase_url + '/digital_signatures/' + vm.operator.company_id + '/' + user.$id)
      const digitalSignatureContact = { contact_id: user.$id, digital_signature: {} } // RETROCOMPATIBILIDADE

      if (vm.digitalSignatureFirebase) {
        vm.digitalSignatureFirebase.on('child_changed', (snapshot) => {
          digitalSignatureContact.digital_signature[snapshot.key()] = snapshot.val()
          mergeFormalizationContactRealTime(digitalSignatureContact)
        })
        vm.digitalSignatureFirebase.on('child_added', (snapshot) => {
          digitalSignatureContact.digital_signature[snapshot.key()] = snapshot.val()
          mergeFormalizationContactRealTime(digitalSignatureContact)
        })
      }
    }

    vm.hasDigitalSignature = () => {
      if (vm.selectedUser[vm.sector_id] && (vm.selectedUser[vm.sector_id].digital_signature || vm.selectedUser[vm.sector_id].new_digital_signature)) {
        if (vm.selectedUser[vm.sector_id].documents_approval) {
          vm.switchTab('documents')
        }

        return true
      }
      return false
    }

    /** end formalization */
    function delLockedContact(contact) {
      ConversationService
        .delLockedContact(
          {
            contactId: contact.$id,
            sectorId: vm.sector_id,
            data: contact
          }
        )
        .$promise
        .then(function (data) {
          if (data.success) {
            NotificationService.successHandler(data, 'Contato removido com sucesso.')
          } else {
            NotificationService.errorHandler(data, 'Erro ao remover o atendimento travado.')
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao remover o atendimento travado.')
        })
    }

    function checkAiClassification() {
      HistoryService
        .getAiClassification({
          contact_id: vm.selectedUser[vm.sector_id].id
        })
        .$promise
        .then(function (data) {
          if (data.result) {
            vm.ai_intent = data.result
          }
        }).catch(function (reponse) {
          NotificationService.errorHandler(reponse, $scope.labels.errSaveClass)
        })
    }

    function setAiClassification(option) {
      HistoryService
        .setAiClassification({
          contact_id: vm.selectedUser[vm.sector_id].id,
          option: option
        })
        .$promise
        .then(function (data) {
          NotificationService.successHandler(data, $scope.labels.sucSave)
        }).catch(function (reponse) {
          NotificationService.errorHandler(reponse, $scope.labels.errSaveData)
        })

      vm.ai_intent = false
    }

    function checkMailing() {
      var contact_id = vm.selectedUser[vm.sector_id].id
      var email = vm.selectedUser[vm.sector_id].data.contact_email

      if (!contact_id || contact_id === 'undefined') {
        return
      }

      MailingCampaignService
        .checkMailing({
          contact_id: contact_id,
          email: email
        })
        .$promise
        .then(function (data) {
          if (data.success && data.result) {
            vm.mailing_campaign.message = data.result.message
            vm.mailing_campaign.date = data.result.created_at

            data.result.expiration_date = data.result.expiration_date ? moment(data.result.expiration_date).format('DD/MM/YYYY') : false
            vm.mailing_campaign.expiration_date = data.result.expiration_date
          }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorLoadCampaign)
        })
    }

    function checkCampaign() {
      var contact_id = vm.selectedUser[vm.sector_id].id
      var email = vm.selectedUser[vm.sector_id].data.contact_email

      if (!contact_id || contact_id === 'undefined') {
        return
      }

      if (email) {
        return
      }

      CampaignService
        .checkCampaign({
          contact_id: contact_id
        })
        .$promise
        .then(function (data) {
          if (data.success && data.result) {
            vm.mailing_campaign.message = data.result.message
            vm.mailing_campaign.date = data.result.created_at
          }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorLoadCampaign)
        })
    }

    function checkAnsweredFromWebhook() {
      let contact_id = vm.selectedUser[vm.sector_id].id

      if (!contact_id || contact_id === 'undefined') {
        return
      }

      ActiveLogService
        .checkAnsweredFromWebhook({
          contact_id
        })
        .$promise
        .then(function (data) {
          if (data.success && data.result) {
            vm.message_from_webhook.message = data.result.message
            vm.message_from_webhook.date = data.result.created_at
          }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorLoadCampaign)
        })
    }

    function checkHsm() {
      let user = vm.selectedUser[vm.sector_id]
      let contact_id = user.id
      let channel_id = user.data.channel_id

      if (!contact_id || contact_id === undefined ||
        !channel_id || channel_id === undefined) {
        return
      }

      MessagesPortalService
        .checkMessageHsm({
          contact_id: contact_id,
          channel_id: channel_id
        })
        .$promise
        .then(function (data) {
          if (data.success && data.result) {
            vm.messageFromHsm.message = data.result.message
            vm.messageFromHsm.date = data.result.created_at.date
          }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorLoadHsm)
        })
    }

    function checkCustomDocuments() {
      CustomDocumentsService
        .checkIfExists()
        .$promise
        .then(function (data) {
          if (data.length > 0) {
            vm.customDocuments = true
          }
        })
        .catch(function (error) {
          errorHandler(error, $scope.labels.errorLoadCustomDocs)
        })
    }

    function validateActiveWaent() {
      if (!vm.activeWaent.hsm_id) {
        return false
      }

      if (!vm.activeWaent.hsmParams) {
        return false
      }

      var hasEmptyHsmParam = false
      for (var hsmParam in vm.activeWaent.hsmParams) {
        if (vm.activeWaent.hsmParams[hsmParam] == '' || vm.activeWaent.hsmParams[hsmParam] == null || vm.activeWaent.hsmParams[hsmParam] == undefined) {
          hasEmptyHsmParam = true
          break
        }
      }

      if (hasEmptyHsmParam) {
        return false
      }

      return true
    }

    vm.sendHsm = function () {
      var user = vm.selectedUser[vm.sector_id]
      vm.activeWaent.channel_id = user.data.channel_id
      vm.activeWaent.phone_number = user.data.contact_phone
      vm.activeWaent.sector_id = vm.sector_id
      vm.activeWaent.is_loading = true

      if (!validateActiveWaent()) {
        NotificationService.warningHandler(null, 'Por favor, preencha os campos obrigatórios!')
        vm.activeWaent.is_loading = false
        return false
      }

      ConversationService.sendHsm({
        'user_id': user.id
      }, {
        'operator_name': vm.operator.display_name,
        'operator_id': vm.operator.id,
        'hsm_id': vm.activeWaent.hsm_id,
        'hsmParams': vm.activeWaent.hsmParams,
        'data': user.data
      })
        .$promise
        .then(function (data, status, headers, config) {
          if (data.success) {
            NotificationService.successHandler(data, 'Mensagem enviada com sucesso!')
            vm.message[vm.protocol] = ''
            vm.backToAttendance()
          } else {
            NotificationService.errorHandler(data, 'Erro ao enviar Modelo de mensagem.')
          }
          $timeout(vm.messageEmojiPicker.forceClose, 100)
          vm.activeWaent.is_loading = false
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, 'Erro ao enviar Modelo de mensagem.')
          vm.showHsm()
          vm.activeWaent.is_loading = false
        })
    }

    function loadHistoryMetadataMetaKey(content, contactId, metaKey) {
      content.label = ''
      HistoryMetadataService
        .loadHistoryMetadata({
          contact_id: contactId,
          meta_key: metaKey
        })
        .$promise
        .then(function (data) {
          content.metadata = { 'value': data.meta_value }
        })
        .catch(function (data) {
          errorHandler(data, $scope.labels.errorMess)
        })
    }

    vm.showAutomaticAnswers = function () {
      if (vm.show_history) {
        NotificationService.warningHandler(null, $scope.labels.closeHistory)
      }
      vm.show_knowledge_base = false
      if (!vm.show_automatic_answers && !vm.show_history) {
        vm.show_automatic_answers = true
      }
    }

    function closeAutomaticAnswersModal() {
      if (vm.show_automatic_answers) {
        vm.selectedCard = null
        vm.cardsData = null
        vm.show_automatic_answers = false
      }
    }

    vm.filterShouldCloseStatus = function () {
      return function (item) {
        if (item.sectors == null) {
          return true
        }

        if (vm.sector_id != null) {
          let sectorValue = item.sectors.split(',').indexOf(vm.sector_id.toString())

          if (sectorValue != -1) {
            return true
          }

          return false
        }
      }
    }

    vm.sendLinkStoneage = function () {
      var user = vm.selectedUser[vm.sector_id]

      ConversationService.sendLinkTelesaqueB2b({
        'user_id': user.id
      }, {
        'extra_data': user
      })
        .$promise
        .then(function (retorno) {
          retorno = retorno.data
          if (retorno.success) {
            NotificationService.successHandler('', retorno.message)
          } else {
            NotificationService.errorHandler('', retorno.message)
          }
        }).catch(function (retorno) {
          retorno = retorno.data
          NotificationService.errorHandler('', retorno.message)
        })
    }

    vm.sendLinkStoneagePayrollV2 = function () {
      var user = vm.selectedUser[vm.sector_id]

      ConversationService.sendLinkPayrollV2({
        'user_id': user.id
      }, {
        'extra_data': user
      })
        .$promise
        .then(function (retorno) {
          retorno = retorno.data
          if (retorno.success) {
            NotificationService.successHandler('', retorno.message)
          } else {
            NotificationService.errorHandler('', retorno.message)
          }
        })
        .catch(function (retorno) {
          retorno = retorno.data
          NotificationService.errorHandler('', retorno.message)
        })
    }

    function getCountriesSms() {
      HistoryService
        .getCountries()
        .$promise
        .then(function (data) {
          if (data) {
            vm.active_sms.countries = data.countries
            getCompanyLocalization()
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, $scope.labels.errorLoadingCountriesSms)
        })
    }

    function getCompanyLocalization() {
      HistoryService
        .getCompanyLocalization()
        .$promise
        .then(function (data) {
          if (data.value) {
            data = JSON.parse(data.value)
            vm.activeSms.ddi = parseInt(data.country)

            vm.active_sms.countries.forEach(function (country) {
              if (data.country == country.id) {
                vm.activeSms.ddi = parseInt(country.ddi)
              }
            })
          } else {
            vm.activeSms.ddi = 55
          }
          changeDdi(vm.activeSms.ddi)
        }).catch(function (data) {
          NotificationService.errorHandler(data, $scope.labels.errorLoadingDdiSms)
          vm.activeSms.ddi = 55
          changeDdi(vm.activeSms.ddi)
        })
    }

    function changeDdi(ddi) {
      vm.active_sms.countries.forEach(function (country, index) {
        if (ddi == country.ddi) {
          vm.active_sms.phoneMask = country.mask ? country.mask : ''
        }
      })
    }

    function getCountriesWhatsAppWeb() {
      HistoryService
        .getCountries()
        .$promise
        .then(function (data) {
          if (data) {
            vm.active_whatsApp.countries = data.countries
            getCompanyLocalizationWhatsAppWeb()
          }
        }).catch(function (data) {
          NotificationService.errorHandler(data, $scope.labels.errorLoadingCountriesWhatsappWeb)
        })
    }

    function getCompanyLocalizationWhatsAppWeb() {
      HistoryService
        .getCompanyLocalization()
        .$promise
        .then(function (data) {
          if (data.value) {
            data = JSON.parse(data.value)
            vm.activeWhatsapp.ddi = parseInt(data.country)

            vm.active_whatsApp.countries.forEach(function (country) {
              if (data.country == country.id) {
                vm.activeWhatsapp.ddi = parseInt(country.ddi)
              }
            })
          } else {
            vm.activeWhatsapp.ddi = 55
          }
          changeDdiWhatsAppWeb(vm.activeWhatsapp.ddi)
        }).catch(
          function (data) {
            NotificationService.errorHandler(data, $scope.labels.errorLoadingDdiWhatsappWeb)
            vm.activeWhatsapp.ddi = 55
            changeDdiWhatsAppWeb(vm.activeWhatsapp.ddi)
          })
    }

    function changeDdiWhatsAppWeb(ddi) {
      vm.active_whatsApp.countries.forEach(function (country, index) {
        if (ddi == country.ddi) {
          vm.active_whatsApp.phoneMask = country.mask ? country.mask : ''
        }
      })
    }

    vm.hasAllowPhoneMask = function (input) {
      return UtilsService.hasAllowPhoneMask(input)
    }

    vm.validateDocumentPermission = () => {
      if ($rootScope.company_metadata.allow && $rootScope.company_metadata['doc_mask'] && $rootScope.company_metadata['doc_mask'].branch == true && $rootScope.company_metadata['doc_mask'].sectors.indexOf(vm.sector_id) > -1) {
        if (
          ($rootScope.company_metadata['doc_mask'].user_operator && $rootScope.profiles.ROLE_OPERATOR == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['doc_mask'].user_manager && $rootScope.profiles.ROLE_MANAGER == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['doc_mask'].user_promoter && $rootScope.profiles.ROLE_PROMOTER == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['doc_mask'].user_administrator && $rootScope.profiles.ROLE_MESSAGES_PORTAL_MANAGER == $rootScope.user_data.role) ||
          ($rootScope.company_metadata['doc_mask'].user_supervisor && $rootScope.profiles.ROLE_MESSAGES_PORTAL_SUPERVISOR == $rootScope.user_data.role)
        ) {
          return false
        }
      }
      return true;
    }

    vm.playAudio = function () {
      if (!vm.audioSource) {
        vm.audioSource = new Audio(vm.file);
      }
      vm.audioSource.play();
      var currentTime = setInterval(() => {
        if (vm.audioSource === null) {
          clearInterval(currentTime);
        }
        if (vm.audioSource !== null && vm.audioSource.currentTime == vm.audioSource.duration) {
          vm.stopAudio();
          clearInterval(currentTime);
        }
      }, 1000);
    };

    vm.stopAudio = function () {
      if (vm.audioSource) {
        vm.audioSource.pause();
        vm.audioSource.currentTime = 0;
      }
      vm.audioSource = null;
    };

    vm.isUploading = false;
    vm.saveMedia = function (e) {
      vm.cancelAttach();
      vm.stopAudio();
      const context = window.AudioContext ? new AudioContext() : new webkitAudioContext();
      var channels = 1; //1 for mono or 2 for stereo
      var sampleRate = context.sampleRate;; //44.1khz (normal mp3 samplerate)
      var kbps = 128; //encode 128kbps mp3
      var mp3encoder = new lamejs.Mp3Encoder(channels, sampleRate, kbps);
      var mp3Data = [];
      var sampleBlockSize = 1152;
      var fileReader = new FileReader();
      fileReader.onloadend = function () {
        var samples = new Int16Array(fileReader.result);

        for (var i = 0; i < samples.length; i += sampleBlockSize) {
          var sampleChunk = samples.subarray(i, i + sampleBlockSize);
          var mp3buf = mp3encoder.encodeBuffer(sampleChunk);
          if (mp3buf.length > 0) {
            mp3Data.push(mp3buf);
          }

        }

        var mp3buf = mp3encoder.flush();

        if (mp3buf.length > 0) {
          mp3Data.push(new Int8Array(mp3buf));
        }

        var blob = new Blob(mp3Data, { type: 'audio/mp3' });
        var file = new File([blob], "record-file.mp3", { type: "audio/mp3" });

        try {
          vm.attach();
          vm.upload(file)
        } catch (e) {
          vm.cancelAttach();
          NotificationService.warningHandler("", "Gravação cancelada.");
        }
      }
      if (vm.recordOnClose) {
        try {
          fileReader.readAsArrayBuffer(e);
        } catch (err) {
          console.log('Erro');
          console.log(err);
        }
      }
    };

    vm.recordOnClose = true;
    vm.startRecording = (recorder) => {
      vm.isRecording = true;
      vm.cancelAttach();
      vm.modelRecorder = recorder;
    }

    vm.stopRecording = (r, e, c) => {
      vm.isRecording = false;
      vm.saveMedia(r);
      vm.modelRecorder = undefined;
    }

    vm.closeRecording = () => {
      if ( angular.element('#stopRecording') ) {
        angular.element('#stopRecording').trigger('click');
      }
    }

    vm.cardInfo = contact => {
      vm.isPayrollV2 = false;
      vm.sent_payroll_v2 = false;
      vm.isTelesqueB2B = false;
      vm.sent_telesaque_b2b = false;
      if (contact && contact.is_payroll_v2) {
        vm.isPayrollV2 = true;
      }
      if (contact.sent_payroll_v2) {
        vm.sent_payroll_v2 = true;
      }
      if (contact && contact.is_telesaque_b2b) {
        vm.isTelesqueB2B = true;
      }
      if (contact.sent_telesaque_b2b) {
        vm.sent_telesaque_b2b = true;
      }
    }
  }
})();
